// EN translation bundle. Generated from the former inline resources in
// src/lib/i18n.ts; loaded on demand (English ships with the entry bundle).
const bundle = {
  translation: {
    common: {
      roleNames: {
        school_admin: 'School admin',
        admin: 'Administrator',
        teacher: 'Teacher',
        parent: 'Parent',
        student: 'Student',
        accountant: 'Accountant',
        secretary: 'Secretary',
        guard: 'Guard',
        bus_driver: 'Bus driver',
        cafeteria_staff: 'Canteen staff',
        emf_agent: 'EMF agent',
        surveillant_general: 'Senior supervisor',
      },
      appName: 'AppAcademia',
      welcome: 'Welcome',
      finance: 'Finance',
      payroll: 'Payroll',
      transport: 'Transport',
      'resources-dms': 'Resources & DMS',
      'school-setup': 'School Setup',
      'admin-analytics': 'Analytics & Reports',
      dashboard: 'Dashboard',
      students: 'Students',
      teachers: 'Teachers',
      lessons: 'Lessons',
      assessments: 'Assessments',
      'exam-prep': 'Exam Prep',
      'lesson-planner': 'Prepare a lesson',
      'ai-tutor': 'AI Tutor',
      gamification: 'Achievements',
      analytics: 'My Progress',
      'teacher-homework': 'Homework',
      'teacher-attendance': 'Attendance',
      'teacher-payslips': 'Payslips',
      'join-school': 'Join a school',
      'emf-portal': 'EMF portal',
      'aya-inbox': 'Aya inbox',
      'catalog-review': 'Catalog review',
      'language-test': 'Language test',
      'grade-entry': 'Grade Entry',
      'teaching-record': 'Teaching record',
      'grade-history': 'Grade History',
      attendance: 'Attendance',
      homework: 'Homework',
      payslips: 'Payslips',
      'teacher-calendar': 'Calendar',
      'parent-portal': 'Parent Portal',
      'parent-homework': 'Homework',
      'parent-attendance': 'Attendance',
      'report-cards': 'Report Cards',
      'parent-communication': 'Messages',
      'school-management': 'School Management',
      'user-management': 'User Management',
      communication: 'Communication',
      parent: 'Parent Portal',
      profile: 'Profile',
      settings: 'Settings',
      logout: 'Logout',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      language: 'Language',
      selectLanguage: 'Select Language',
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
      continue: 'Continue',
      submitting: 'Submitting...',
      close: 'Close',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      ok: 'OK',
      viewDetails: 'View Details',
      learnMore: 'Learn More',
      download: 'Download',
      upload: 'Upload',
      share: 'Share',
      export: 'Export',
      import: 'Import',
      refresh: 'Refresh',
      retry: 'Retry',
      validate: 'Validate',
      validating: 'Validating...',
      noDataAvailable: 'No data available',
      comingSoon: 'Coming Soon',
      somethingWentWrong: 'Something went wrong',
      oopsSomethingWentWrong: 'Oops! Something went wrong',
      unexpectedError: 'An unexpected error occurred. Please try again.',
      unexpectedErrorReload: 'We encountered an unexpected error. You can try reloading the page or head back to the dashboard.',
      tryAgain: 'Try Again',
      goToDashboard: 'Go to Dashboard',
      add: 'Add',
      saving: 'Saving...',
      'admin-setup': 'Admin Setup',
      'attendance-scanner': 'Attendance Scanner',
      cafeteria: 'Cafeteria',
      emfPortal: 'EMF Portal',
      suivi: 'Student Follow-up',
      'parent-suivi': 'Follow-up',
      pricing: 'Pricing',
      noResults: 'No results',
      closeSidebar: 'Close sidebar',
      openSidebar: 'Open sidebar',
      accounting: 'Accounting',
      breadcrumb: 'Breadcrumb',
      home: 'Home',
      status: 'Status',
      actions: 'Actions',
      more: 'more',
      active: 'Active',
      inactive: 'Inactive',
      view: 'View',
      previous: 'Previous',
      na: 'N/A',
      print: 'Print',
      none: 'None',
      notSpecified: 'Not specified',
      noneSpecified: 'None specified',
      adding: 'Adding...',
    },
    sidebar: {
      management: 'Management',
      teachingTools: 'Teaching Tools',
      schoolLife: 'School life',
      communication: 'Communication & Settings',
      familyPortal: 'Family',
    },
    errors: {
      general: 'An error occurred. Please try again.',
      pageNotFound: 'Page not found',
      pageNotFoundDescription: "The page you're looking for doesn't exist or has been moved.",
      goToDashboard: 'Go to Dashboard',
      goHome: 'Go Home',
      network: 'Network error. Please check your connection.',
      unauthorized: 'Unauthorized. Please login again.',
      forbidden: 'You do not have permission to perform this action.',
      notFound: 'The requested resource was not found.',
      serverError: 'Server error. Please try again later.',
      validation: 'Please check your input and try again.',
      fileUpload: 'File upload failed. Please try again.',
      fileSizeLimit: 'File size exceeds the limit.',
      invalidFileType: 'Invalid file type.',
      sessionExpired: 'Your session has expired. Please login again.',
    },
    notifications: {
      success: 'Success',
      error: 'Error',
      warning: 'Warning',
      info: 'Information',
      saved: 'Your changes have been saved.',
      deleted: 'Successfully deleted.',
      updated: 'Successfully updated.',
      created: 'Successfully created.',
      copied: 'Copied to clipboard.',
      sent: 'Successfully sent.',
      loading: 'Loading, please wait...',
      processing: 'Processing, please wait...',
      completed: 'Completed successfully.',
      title: 'Notifications',
      markAllRead: 'Mark all read',
      empty: 'No notifications yet',
    },
    subscription: {
      freePlan: 'Free Plan',
      trial: 'Trial',
      upgrade: 'Upgrade for unlimited access →',
    },
    landing: {
      nav: {
        signIn: 'Sign In',
        tryDemo: 'Try Demo',
        getStarted: 'Get Started',
      },
      hero: {
        subtitle: 'The Complete School Management Platform',
        titleLine1: 'Run Your Entire School',
        titleLine2: 'From One Dashboard.',
        title: 'Run Your Entire School — From One Dashboard.',
        description: 'Attendance, grades, report cards, fee collection, payroll, parent communication, AI tutoring — all managed from a single platform designed for K-12 schools.',
        primaryCTA: 'Get Started Free',
        secondaryCTA: 'Watch Demo',
        trustNoCc: 'No credit card',
        trustSetup: 'Set up in 60s',
        trustK12: 'K-12 ready',
        mockup: {
          schoolName: 'Lycée International de Douala',
          students: 'Students',
          attendance: 'Attendance',
          gradesFilled: 'Grades Filled',
          feesCollected: 'Fees Collected',
        },
      },
      featuresSection: {
        title: 'Everything You Need for Modern Education',
        description: 'Comprehensive tools designed to enhance teaching, accelerate learning, and connect families.',
      },
      features: {
        aiLearning: {
          title: 'AI-Powered Learning',
          description: 'Personalized education paths adapted to each student\'s unique learning style and pace.',
          badge: 'Adaptive AI',
        },
        teacherCopilot: {
          title: 'Teacher Copilot',
          description: 'Intelligent assistant for lesson planning, content generation, and student assessment.',
          badge: 'Save Time',
        },
        multilingualSupport: {
          title: 'Multilingual Support',
          description: 'Full support for English, Spanish, French, German, and Portuguese with culturally relevant content.',
          badge: 'Global',
        },
        analytics: {
          title: 'Real-time Analytics',
          description: 'Track student progress with comprehensive dashboards and actionable insights.',
          badge: 'Data-Driven',
        },
        interactiveContent: {
          title: 'Interactive Content',
          description: 'Engaging 3D lessons with WebXR support for immersive learning experiences.',
          badge: 'VR/AR Ready',
        },
        selIntegration: {
          title: 'SEL Integration',
          description: 'Social-emotional learning tools and career path exploration for holistic development.',
          badge: 'Whole Child',
        },
      },
      stats: {
        schoolsUsing: 'Schools Using AppAcademia',
        studentsManaged: 'Students Managed',
        avgAttendance: 'Average Attendance Rate',
        directorRating: 'School Director Rating',
      },
      cta: {
        title: 'Ready to transform your school?',
        description: 'Join hundreds of schools already using AppAcademia to streamline operations and improve learning outcomes.',
        primary: 'Create Free Account',
        secondary: 'Sign In',
        tertiary: 'Try Interactive Demo',
      },
      personasSection: {
        title: 'Built for everyone in education',
        desc: 'Whether you\'re an individual or part of a school, AppAcademia adapts to your role and needs.',
      },
      personas: {
        student: {
          title: 'Student',
          desc: 'Personalized AI tutoring, exam prep, and adaptive learning paths.',
          b1: 'AI Tutor available 24/7',
          b2: 'Exam prep with practice tests',
          b3: 'Gamified learning with XP & badges',
          cta: 'Start Learning',
        },
        teacher: {
          title: 'Teacher',
          desc: 'Copilot for lesson planning, grade management, and student insights.',
          b1: 'AI lesson planning assistant',
          b2: 'Grade filling — web & mobile',
          b3: 'Student performance analytics',
          cta: 'Join as Teacher',
        },
        parent: {
          title: 'Parent',
          desc: 'Track your child\'s progress, view report cards, and communicate with school.',
          b1: 'Real-time progress dashboard',
          b2: 'Digital report cards & grades',
          b3: 'Direct messaging with teachers',
          cta: 'Join as Parent',
        },
        school: {
          title: 'School Admin',
          desc: 'Complete school management — from attendance to report cards to analytics.',
          b1: 'Attendance, grades & bulletins',
          b2: 'Timetables & teacher management',
          b3: 'School-wide analytics dashboard',
          cta: 'Set Up School',
        },
      },
      schoolMgmt: {
        tag: 'School Management',
        title: 'Everything Your School Needs, In One Place',
        desc: 'A complete management suite — attendance, grades, fees, payroll, and 16+ modules. No extra software needed.',
        cta: 'Discover all features',
        showLess: 'Show less',
        getStarted: 'Set up your school free',
        catAcademic: 'Academic',
        catAdmin: 'Administrative',
        catComm: 'Communication',
        catIntel: 'Intelligence',
        attendance: 'Attendance',
        attendanceDesc: 'Daily tracking, absence alerts, reports',
        reportCards: 'Report Cards',
        reportCardsDesc: 'Auto-generated bulletins per term',
        grades: 'Grade Filling',
        gradesDesc: 'Web & mobile grade entry by teachers',
        timetables: 'Timetables',
        timetablesDesc: 'Class schedules & room allocation',
        communication: 'Messaging',
        communicationDesc: 'Teacher-parent-student messaging',
        analytics: 'Analytics',
        analyticsDesc: 'School-wide performance dashboards',
        fees: 'Fee Collection',
        feesDesc: 'Tuition billing & payment tracking',
        payroll: 'Teacher Payroll',
        payrollDesc: 'Salary management & payslips',
        transport: 'Transport',
        transportDesc: 'Bus routes & student tracking',
        inventory: 'Inventory',
        inventoryDesc: 'School supplies & asset management',
        documents: 'Documents',
        documentsDesc: 'Digital document storage & sharing',
        sms: 'SMS & Alerts',
        smsDesc: 'SMS, WhatsApp & push notifications',
        homework: 'Homework',
        homeworkDesc: 'Assignment creation & submission',
        appointments: 'Appointments',
        appointmentsDesc: 'Parent-teacher meeting scheduler',
        aiTutor: 'AI Tutor',
        aiTutorDesc: '24/7 AI-powered student support',
        examPrep: 'Exam Prep',
        examPrepDesc: 'Practice tests & exam simulations',
        parentPortal: 'Parent Portal',
        parentPortalDesc: 'Dedicated parent access & insights',
        tracking: 'Student Tracking',
        trackingDesc: 'Progress monitoring & early alerts',
      },
      seeItInAction: {
        title: 'See It In Action',
        desc: 'Explore the platform from every perspective — admin, teacher, parent, or accountant.',
        tabAdmin: 'School Admin',
        tabTeacher: 'Teacher',
        tabParent: 'Parent',
        tabAccounting: 'Accounting',
        adminTitle: 'School Administration Dashboard',
        adminTotalStudents: 'Total Students',
        adminTotalTeachers: 'Total Teachers',
        adminAttendance: 'Attendance Today',
        adminRevenue: 'Monthly Revenue',
        adminStaff: 'Staff',
        teacherTitle: 'Teacher Dashboard',
        teacherMyClasses: 'My Classes',
        teacherPendingGrades: 'Pending Grades',
        teacherAvgScore: 'Avg. Score',
        teacherGradeEntry: 'Grade Entry — Mathematics 3ème',
        parentTitle: 'Parent Dashboard',
        parentChildName: 'Amina Kenfack — 4ème A',
        parentAverage: 'Average',
        parentRank: 'Rank',
        parentAbsences: 'Absences',
        parentViewReportCard: 'View Report Card',
        parentMessageTeacher: 'Message Teacher',
        parentPayFees: 'Pay Fees',
        parentViewTimetable: 'View Timetable',
        accountingTitle: 'Financial Dashboard',
        accCollected: 'Fees Collected',
        accPending: 'Pending',
        accPayroll: 'Payroll',
        accExpenses: 'Expenses',
        accMonthlyOverview: 'Monthly Collection Overview',
      },
      testimonials: {
        title: 'Trusted by Schools Across Africa & Beyond',
        subtitle: 'Hear from directors, teachers, parents, and bursars who use AppAcademia daily.',
        t1: {
          quote: 'AppAcademia transformed how I manage my school. Report cards, attendance, fees — all in one place. We replaced 3 different tools.',
          name: 'Daniel M.',
          role: 'School Director',
        },
        t2: {
          quote: 'The AI tutor explains things until I understand. The badges and streaks make studying actually fun!',
          name: 'Emma R.',
          role: '10th Grade Student',
        },
        t3: {
          quote: 'I can finally track my children\'s grades and communicate with teachers directly from my phone. A game-changer for parents.',
          name: 'Aissatou D.',
          role: 'Parent of 3',
        },
        t4: {
          quote: 'Fee collection is now effortless. Parents pay online, and I have a clear view of all transactions. No more cash headaches.',
          name: 'Jean-Claude T.',
          role: 'School Bursar',
        },
        t5: {
          quote: 'We replaced 3 separate tools with AppAcademia. Now grades, attendance, and parent communication are all in one system.',
          name: 'Marie-Claire O.',
          role: 'School Founder',
        },
      },
      pricing: {
        title: 'Simple, Transparent Pricing',
        subtitle: 'Plans starting from 1,500 XAF/student/year. Start free, upgrade when you\'re ready.',
        popular: 'Most Popular',
        starter: {
          name: 'Starter',
          price: 'Free',
          period: '',
          f1: 'Up to 50 students',
          f2: 'Attendance & grades',
          f3: 'Report card generation',
          f4: 'Parent messaging',
          cta: 'Start Free',
        },
        pro: {
          name: 'Professional',
          price: '3,500 XAF',
          period: '/student/year',
          f1: 'Unlimited students',
          f2: 'All management modules',
          f3: 'AI Tutor & Exam Prep',
          f4: 'Fee collection & payroll',
          f5: 'SMS & WhatsApp alerts',
          cta: 'Get Started',
        },
        enterprise: {
          name: 'Enterprise',
          price: 'Custom',
          period: '',
          f1: 'Multi-campus support',
          f2: 'Custom branding & domain',
          f3: 'API access & integrations',
          f4: 'Dedicated account manager',
          f5: 'On-premise deployment option',
          cta: 'Contact Sales',
        },
      },
      trust: {
        secure: 'COPPA & FERPA',
        secureDesc: 'Enterprise-grade security. Student data stays protected.',
        global: '5 Languages',
        globalDesc: 'English, French, Spanish, German, Portuguese — built in.',
        fast: 'Free to start',
        fastDesc: 'No credit card. Set up in 60 seconds. Cancel anytime.',
      },
      steps: {
        title: 'Get started in minutes',
        subtitle: 'Three simple steps to transform your school management.',
        s1: { title: 'Create your account', desc: 'Sign up in seconds — as student, teacher, parent, or school admin. No credit card required.' },
        s2: { title: 'Set up your school', desc: 'Add your classes, teachers, and students. Import data or start fresh. Our AI helps you configure everything.' },
        s3: { title: 'Start managing', desc: 'Track attendance, fill grades, generate report cards, collect fees — all from day one.' },
      },
      footer: {
        rights: '© 2026 AppAcademia. All rights reserved.',
        poweredBy: 'Powered by AppAcademia',
        tagline: 'AI-powered school management and learning platform for every K-12 institution.',
        googlePlay: 'Get it on Google Play',
        product: 'Product',
        forSchools: 'For Schools',
        forStudents: 'For Students',
        resources: 'Resources',
        blog: 'Blog',
        apiDocs: 'API Documentation',
        changelog: 'Changelog',
        support: 'Support',
        helpCenter: 'Help Center',
        contactUs: 'Contact Us',
        liveChat: 'Live Chat',
        legal: 'Legal',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        deleteAccount: 'Delete Account',
        coppa: 'COPPA Compliance',
      },
    },
    onboarding: {
      nav: {
        backToHome: 'Back to Home',
        signIn: 'Sign In',
      },
      hero: {
        trust: 'Trusted by 10,000+ schools worldwide',
        title: 'Choose Your Path to Success',
        description: 'Whether you\'re setting up an entire school or starting your individual journey, we\'ll guide you through a tailored onboarding experience designed for your specific needs.',
        setupInMinutes: 'Setup in minutes',
        awardWinning: 'Award-winning platform',
        aiPowered: 'AI-powered insights',
      },
      paths: {
        quickStudent: {
          title: 'Try as Student',
          subtitle: 'Quick Start - No Setup Required',
          description: 'Perfect for students or anyone who wants to explore the platform immediately. Start learning in under 60 seconds with our demo environment.',
          buttonText: 'Start Now (60 sec)',
          recommended: 'Fastest',
          estimatedTime: '1 min',
          difficulty: 'Beginner',
          features: {
            noVerification: 'No email verification needed',
            instantAccess: 'Instant access to lessons',
            fullDashboard: 'Full student dashboard',
            trackProgress: 'Track your progress',
            aiTutor: 'Try AI tutor immediately',
            connectLater: 'Connect to real school later',
          },
          benefits: {
            instantAccess: 'Instant Access',
            noBarriers: 'No Barriers',
            tryFirst: 'Try First',
          },
        },
        schoolAdmin: {
          title: 'Set Up Your School',
          subtitle: 'Complete School Administration',
          description: 'Perfect for school administrators, principals, and IT directors who need to configure the entire school system with advanced features and controls.',
          buttonText: 'Configure School',
          recommended: 'For Administrators',
          estimatedTime: '10-15 min',
          difficulty: 'Advanced',
          features: {
            management: 'Complete school management dashboard',
            staffInvitation: 'Staff invitation & role management',
            customBranding: 'Custom branding & domain setup',
            analytics: 'Advanced analytics & reporting',
            multiGrade: 'Multi-grade level configuration',
            portalSetup: 'Parent & teacher portal setup',
          },
          benefits: {
            fullControl: 'Full Control',
            advancedFeatures: 'Advanced Features',
            scalable: 'Scalable',
          },
        },
        individual: {
          title: 'Join as Teacher/Parent',
          subtitle: 'Professional Learning Workspace',
          description: 'For educators and parents who want to create content, manage learning, and collaborate professionally. Perfect for individual use with the option to connect to schools later.',
          buttonText: 'Start as Professional',
          recommended: 'For Educators',
          estimatedTime: '3-5 min',
          difficulty: 'Beginner',
          features: {
            professionalTools: 'Instant access to professional tools',
            createContent: 'Create lessons & assessments',
            goalBased: 'Goal-based recommendations',
            progressTracking: 'Progress tracking & analytics',
            connectLater: 'Connect to schools later',
            networking: 'Professional networking',
          },
          benefits: {
            quickStart: 'Quick Start',
            flexible: 'Flexible',
            professional: 'Professional',
          },
        },
        demo: {
          title: 'Interactive Demo',
          subtitle: 'Explore Without Commitment',
          description: 'Experience all features with our comprehensive demo environment. No signup required - explore realistic scenarios with sample data.',
          buttonText: 'Launch Demo',
          recommended: 'Try First',
          estimatedTime: '5-10 min',
          difficulty: 'Beginner',
          features: {
            noRegistration: 'No account registration needed',
            fullExploration: 'Full feature exploration',
            multiplePerspectives: 'Multiple user role perspectives',
            sampleEnvironment: 'Sample school environment',
            guidedTutorials: 'Guided interactive tutorials',
            realisticScenarios: 'Realistic educational scenarios',
          },
          benefits: {
            noCommitment: 'No Commitment',
            fullPreview: 'Full Preview',
            riskFree: 'Risk-Free',
          },
        },
      },
      common: {
        keyFeatures: 'Key Features:',
        moreFeatures: '+{{count}} more features',
        users: 'users',
      },
      alternative: {
        title: 'Looking for something specific?',
        description: 'We have additional options for special situations and enterprise needs.',
        withInvitation: {
          title: 'Join with Invitation',
          subtitle: 'Already invited by a school?',
        },
        enterprise: {
          title: 'Enterprise Sales',
          subtitle: 'Need custom solutions?',
        },
      },
      footer: {
        secure: '100% secure setup',
        gdpr: 'GDPR compliant',
        soc2: 'SOC 2 certified',
        questions: 'Still have questions about which path is right for you?',
        talkToTeam: 'Talk to our team',
        browseDocs: 'Browse help docs',
      },
      personas: {
        student: {
          title: "I'm a Student",
          subtitle: 'Learn, practice & grow',
          bullet1: 'AI-powered personalized lessons',
          bullet2: 'Practice exercises & quizzes',
          bullet3: 'Track your progress',
        },
        teacher: {
          title: "I'm a Teacher",
          subtitle: 'Create & manage classes',
          bullet1: 'Create content & lesson plans',
          bullet2: 'Manage your classes',
          bullet3: 'Track student progress',
        },
        parent: {
          title: "I'm a Parent",
          subtitle: "Support your child's learning",
          bullet1: "Monitor your child's progress",
          bullet2: 'Communicate with teachers',
          bullet3: 'Get learning insights',
        },
        admin: {
          title: "I'm a School Administrator",
          subtitle: 'Run your school platform',
          bullet1: 'Manage your school & staff',
          bullet2: 'Invite teachers & students',
          bullet3: 'Analytics & reporting',
        },
      },
      popular: 'Most Popular',
      getStarted: 'Get Started',
      forSchools: 'For schools',
      orContinueWith: 'or continue with',
      continueWithGoogle: 'Continue with Google',
      alreadyHaveAccount: 'Already have an account?',
      signIn: 'Sign in',
      tryDemo: 'Try Demo — No account needed',
      howWillYouUse: 'How will you use',
      chooseRole: 'Choose your role to get a personalized experience',
    },
    individualSignup: {
      nav: { back: 'Back' },
      step1: {
        title: 'How will you use AppAcademia?',
        subtitle: 'Choose your role to get the best experience.',
        teacher: {
          label: "I'm a Teacher",
          desc: 'Lesson planning, grade filling, AI copilot',
        },
        parent: {
          label: "I'm a Parent",
          desc: "Track your child's progress, report cards, exam prep",
        },
        studentLink: 'Student?',
        studentCta: 'Sign up here',
        adminLink: 'School admin?',
        adminCta: 'Set up your school',
      },
      step2Teacher: {
        badge: 'Teacher',
        title: 'Are you part of a school?',
        subtitle: 'This helps us set up your workspace correctly.',
        school: {
          label: 'My school uses AppAcademia',
          desc: 'I have a school code to join my institution',
        },
        solo: {
          label: "I'm an independent teacher",
          desc: 'I want to use the AI copilot, organize my lessons',
        },
        note: 'You can always join or recommend a school later.',
      },
      step2Parent: {
        badge: 'Parent',
        title: 'How will you use AppAcademia?',
        subtitle: "We'll tailor your dashboard to your needs.",
        school: {
          label: "I received a code from my child's school",
          desc: 'Follow grades, attendance, report cards, and communicate with teachers',
        },
        independent: {
          label: 'I want my child to learn & prepare exams',
          desc: 'AI tutor, exam prep, adaptive learning — no school required',
        },
      },
      step3: {
        teacherBadge: 'Teacher',
        parentBadge: 'Parent',
        schoolContext: 'School',
        soloContext: 'Independent',
        examPrepContext: 'Exam Prep',
        title: 'Create your account',
        subtitle: 'It takes less than a minute. No credit card needed.',
        continueWithGoogle: 'Continue with Google',
        orWithEmail: 'or with email',
        fullName: 'Full name',
        fullNamePlaceholder: 'John Doe',
        email: 'Email',
        emailPlaceholder: 'john@example.com',
        password: 'Password',
        passwordPlaceholder: 'At least 8 characters',
        schoolCodeLabel: 'School code',
        schoolInvitationLabel: 'School invitation code',
        schoolCodePlaceholder: 'e.g. SCHOOL-ABC123',
        schoolCodeHintParent: "Ask your child's school for this code. You can also add it later.",
        schoolCodeHintTeacher: 'Your school admin can provide this code. You can also join later.',
        aboutChild: 'About your child',
        childName: "Child's name",
        childNamePlaceholder: 'First name',
        gradeLevel: 'Grade level',
        gradeSelect: 'Select',
        gradeName: 'Grade {{n}}',
        addMoreLater: 'You can add more children later from your dashboard.',
        whatYouGet: "What you'll get",
        submitButton: 'Create Free Account',
        submitting: 'Creating account…',
        alreadyHaveAccount: 'Already have an account?',
        signIn: 'Sign in',
      },
      benefits: {
        teacherSchool: ['Access to your school\'s classes & students', 'Grade filling — web & mobile', 'AI-powered lesson planning'],
        teacherSolo: ['AI copilot for lesson preparation', 'Personal content library', 'Student analytics tools'],
        parentSchool: ['Your child\'s grades & report cards', 'Attendance and absence tracking', 'Direct messaging with teachers'],
        parentIndependent: ['AI tutor for your child — 24/7', 'Exam prep with practice tests', 'Progress tracking dashboard'],
      },
      toasts: {
        welcome: 'Welcome to AppAcademia!',
        welcomeBack: 'Welcome back!',
        signedIn: "You're now signed in.",
        accountReady: 'Your account is ready.',
        joinedSchool: "Welcome! You've joined {{school}}.",
        theSchool: 'the school',
        accountActive: 'Welcome! Your account is active.',
        accountCreated: 'Account created!',
        missingFields: 'Missing fields',
        missingFieldsDesc: 'Please fill in all required fields.',
        passwordTooShort: 'Password too short',
        passwordTooShortDesc: 'Password must be at least 8 characters.',
        signInFailed: 'Sign-in failed',
        signInFailedDesc: 'Could not authenticate with Google.',
        googleNotAvailable: 'Google Sign-In not available',
        googleNotAvailableDesc: 'Please use email registration instead.',
        error: 'Error',
        emailTaken: 'An account already uses this e-mail: sign in, then enter the code in your space.',
        signupFailed: 'Signup failed.',
        unexpectedError: 'An unexpected error occurred.',
        childLogin: 'Login for {{name}}',
      },
      loading: 'Creating your account…',
      goals: {
        teachingSchool: 'Teaching within a school',
        teachingIndependent: 'Independent teaching',
        lessonPlans: 'Create engaging lesson plans',
        trackProgress: 'Track student progress',
        followChild: 'Follow child at school',
        prepareExams: 'Prepare child for exams',
        supportLearning: "Support child's learning at home",
      },
    },
    schoolSetup: {
      errors: {
        schoolName: 'School name must be at least 2 characters',
        schoolType: 'Please select a school type',
        email: 'Please enter a valid email address',
        adminName: 'Administrator name must be at least 2 characters',
        gradeLevels: 'Please select at least one grade level',
        terms: 'Accept the terms of service to continue',
      },
      steps: {
        school: { title: 'Your School', description: 'Basic information about your institution' },
        admin: { title: 'Administrator', description: 'Your login credentials' },
        details: { title: 'Grade Levels', description: 'Grade levels offered' },
        terms: { title: 'Confirmation', description: 'Review and confirm' },
      },
      schoolTypes: {
        public: 'Public school',
        private: 'Private school',
        confessional: 'Faith-based school',
        bilingual: 'Bilingual school',
        technical: 'Technical school',
        charter: 'Charter school',
        homeschool: 'Homeschool',
        university: 'University',
      },
      gradeLevels: {
        primaryTitle: 'Primary',
        secondaryTitle: 'Secondary',
      },
      form: {
        schoolName: 'School name',
        schoolNamePlaceholder: 'e.g. Lycée de Yaoundé',
        schoolType: 'School type',
        schoolEmail: 'School email',
        schoolEmailPlaceholder: 'contact@school.com',
        adminName: 'Full name',
        adminNamePlaceholder: 'John Doe',
        adminEmail: 'Email',
        adminEmailPlaceholder: 'admin@school.com',
        adminPassword: 'Password',
        adminPasswordPlaceholder: 'At least 8 characters',
        passwordHint: 'Must contain uppercase, lowercase and a number',
        continueWithGoogle: 'Continue with Google',
        orFillManually: 'or fill in manually',
        selectGrades: 'Select grade levels offered at your school',
        termsLabel: 'I accept the Terms of Service and Privacy Policy',
      },
      nav: {
        back: 'Back',
        next: 'Next',
        createSchool: 'Create School',
        creating: 'Creating…',
      },
      summary: {
        title: 'Summary',
        schoolName: 'School',
        schoolType: 'Type',
        admin: 'Administrator',
        grades: 'Grade levels',
      },
      toasts: {
        success: 'School Created Successfully!',
        successDesc: 'Your school has been set up. You can now start inviting teachers and students.',
        error: 'Registration Error',
        validationError: 'Please fix the errors before continuing.',
        googleLinked: 'Google account linked',
        googleLinkedDesc: 'Your name and email have been filled in automatically.',
      },
      // Admin-page SchoolSetup keys
      schoolYears: 'School Years',
      classes: 'Classes',
      subjects: 'Subjects',
      assignments: 'Assignments',
      competencies: 'Competencies',
      email: 'Email',
      current: 'Current',
      currentYear: 'Current year',
      newSchoolYear: 'New school year',
      createYear: 'Create school year',
      startDate: 'Start date',
      endDate: 'End date',
      name: 'Name',
      code: 'Code',
      level: 'Level',
      maxCapacity: 'Max capacity',
      category: 'Category',
      coef: 'Coef.',
      coefficient: 'Coefficient',
      general: 'General',
      scientific: 'Scientific',
      literary: 'Literary',
      sports: 'Sports',
      artistic: 'Artistic',
      technical: 'Technical',
      primary: 'Primary',
      secondary: 'Secondary',
      newClass: 'New class',
      newSubject: 'New subject',
      newCompetency: 'New competency',
      addSubject: 'Add a subject',
      addSubjectsHint: 'Add subjects to the curriculum',
      classAdded: 'Class "{{name}}" added.',
      subjectAdded: 'Subject "{{name}}" added.',
      competencyAdded: 'Competency "{{name}}" added.',
      nameRequired: 'Name is required.',
      nameCodeRequired: 'Name and code are required.',
      fillRequired: 'Please fill in the required fields.',
      createError: 'Error creating item',
      saveError: 'Error saving',
      notEditable: 'Not editable',
      createFirstYear: 'Create a school year first',
      createClassesFirst: 'Create classes first',
      createSubjectsFirst: 'Create subjects first',
      classCount: '{{count}} classes',
      description: 'Description',
      domain: 'Domain',
      term: 'Term',
      defineTerms: 'Define terms',
      termsAutoGenerated: 'Terms are auto-generated.',
      assign: 'Assign',
      assignDesc: 'Assign teachers to subjects and classes',
      assignSubject: 'Assign a subject',
      teacher: 'Teacher',
      student: 'Student',
      students: 'Students',
      subject: 'Subject',
      class: 'Class',
      enroll: 'Enroll',
      enrollDesc: 'Enroll students in their classes to enable report cards, attendance, and grade entry.',
      enrollStudent: 'Enroll a student in a class',
      enrolledStudents: 'Enrolled students',
      noEnrolledStudents: 'No students enrolled in this class.',
      studentAlreadyEnrolled: 'This student is already enrolled in this class.',
      studentEnrolled: 'Student enrolled successfully.',
      studentOrClassNotFound: 'Student or class not found. Please refresh and try again.',
      enrollError: 'Error enrolling student. Please try again.',
      searchStudent: 'Search by name...',
      noStudentFound: 'No matching student found.',
      addStudentsFirst: 'Add students first via the Students page.',
      moveStudent: 'Move to another class',
      moveStudentTo: 'Move student to another class',
      selectTargetClass: 'Select target class',
      move: 'Move',
      studentMoved: 'Student moved successfully.',
      alreadyInTarget: 'Student is already in the target class.',
      moveError: 'Error moving student.',
      removeStudent: 'Remove from class',
      confirmRemove: 'Remove {{name}} from this class?',
      studentRemoved: '{{name}} removed.',
      removeError: 'Error removing student.',
      subjectAlreadyAssigned: 'Subject already assigned',
      subjectAssigned: 'Subject assigned successfully',
      inviteTeachers: 'Invite teachers',
      inviteStudents: 'Invite students',
      configure: 'Configure',
      optionalDesc: 'Description (optional)',
      emailConfig: 'Email configuration',
      emailHowItWorks: 'Emails will be sent from your school address.',
      emailSaved: 'Email configuration saved',
      senderName: 'Sender name',
      senderNameDesc: 'The name displayed in sent emails',
      senderNamePlaceholder: 'e.g. Lycée de Yaoundé',
      sendingAddress: 'Sending address',
      replyTo: 'Reply-to address',
      replyToDesc: 'Replies will be sent to this address',
      replyToPlaceholder: 'contact@school.com',
      senderPreview: 'Sender preview',
      customSignature: 'Custom signature',
      signatureDesc: 'Add a signature to outgoing emails',
      signaturePlaceholder: 'Best regards,\nThe administration',
      competenciesPrimary: 'Competencies (primary)',
      primaryCompetencies: 'Primary competencies',
      secondaryCoefficients: 'Coefficients (secondary)',
      signupLegal: {
        and: 'and the',
        dpa: 'data processing agreement (pupils and staff data)',
        notice: 'By creating the school, you accept on its behalf the',
        terms: 'terms of service',
      },
    },
    adminSetup: {
      createInviteLink: 'Create a link for teachers',
      stepLabel: 'Step {{step}} — {{label}}',
      title: 'School configuration',
      subtitle: 'Complete these steps to get started',
      steps: {
        year: 'School year',
        classes: 'Classes',
        subjects: 'Subjects',
        invite: 'Invite teachers',
      },
      yearName: 'School year name',
      startDate: 'Start date',
      endDate: 'End date',
      markCurrent: 'Mark as current year',
      trimesterNote: '3 trimesters will be created automatically.',
      createYear: 'Create school year',
      createClasses: 'Create classes',
      addSubjects: 'Add subjects',
      competencies: 'Competency areas (primary)',
      subjectsCoeff: 'Subjects with coefficients (secondary)',
      selectAll: 'Select all',
      coeff: 'Coeff.',
      teacherEmails: 'Teacher email addresses',
      emailPlaceholder: 'teacher1@school.com\nteacher2@school.com',
      inviteCount: 'invitation(s) to send',
      inviteLink: 'Invitation link',
      shareLinkHint: 'Share this link to invite teachers directly.',
      emailNote: 'Teachers will receive an email with a sign-up link.',
      sending: 'Sending…',
      sendInvites: 'Send invitations',
      finishSetup: 'Finish setup',
      inviteSent: 'Invitation(s) sent',
      inviteDescription: 'Teachers will receive an email.',
      schoolReady: 'Your school is ready!',
      redirecting: 'Redirecting…',
      finish: 'Finish',
      skipStep: 'Skip this step',
      configureLater: 'You can configure this later',
      errors: {
        inviteLink: 'Could not create the link.',
        createYear: 'Could not create the school year.',
        createClasses: 'Could not create the classes.',
        createSubjects: 'Could not create the subjects.',
        sendInvites: 'Could not send the invitations.',
      },
    },
    quickStudentSignup: {
      nav: {
        signIn: 'Sign In',
        otherOptions: 'Other Options',
      },
      hero: {
        badge: 'Fastest Way to Start',
        title: 'Start Learning in',
        subtitle: 'Under 60 Seconds',
        description: 'No verification needed. No waiting. Just immediate access to world-class learning.',
      },
      features: {
        instantAccess: {
          title: 'Instant Access',
          description: 'Start with our demo school environment immediately',
        },
        aiPowered: {
          title: 'AI-Powered Learning',
          description: 'Personal AI tutor available 24/7 to help you learn',
        },
        connectLater: {
          title: 'Connect Later',
          description: 'Link to your real school whenever you\'re ready',
        },
        trackProgress: {
          title: 'Track Progress',
          description: 'Analytics dashboard shows your learning journey',
        },
      },
      trust: {
        freeForever: 'Free Forever',
        noCredit: 'No Credit Card',
        cancelAnytime: 'Cancel Anytime',
      },
      form: {
        cardTitle: 'Create Your Account',
        cardDescription: 'Join 25,000+ students learning with AppAcademia',
        setupBadge: 'Setup takes less than 1 minute',
        fullName: 'Full Name',
        fullNamePlaceholder: 'Alex Johnson',
        email: 'Email Address',
        emailPlaceholder: 'you@example.com',
        password: 'Password',
        passwordPlaceholder: 'Minimum 8 characters',
        passwordHint: 'At least 8 characters for security',
        submitLoading: 'Creating your account...',
        submitButton: 'Start Learning Now',
        terms: 'By signing up, you agree to our',
        termsLink: 'Terms of Service',
        and: 'and',
        privacyLink: 'Privacy Policy',
        alreadyHave: 'Already have an account?',
        signInInstead: 'Sign in instead',
      },
      toasts: {
        successTitle: 'Welcome to AppAcademia! 🎉',
        successDescription: 'Your account has been created. Let\'s start learning!',
        failedTitle: 'Registration Failed',
      },
      errors: {
        googleNotConfiguredTitle: 'Google Sign-In',
        googleNotConfigured: 'Google Sign-In is not configured yet. Please use email registration.',
        googleAuthFailed: 'Google authentication failed. Please try email signup.',
      },
      consent: {
        birthDate: 'Date of birth',
        birth_date_invalid: 'This date of birth does not look right.',
        birth_date_required: 'Please enter your date of birth.',
        checkForm: 'Please check the form and try again.',
        parentEmail: 'Your parent\'s or guardian\'s e-mail',
        parentEmailHint: 'You are under {{age}}: a parent must approve your account before you can use it. We will e-mail them a link.',
        parentEmailPlaceholder: 'parent@example.com',
        parent_email_must_differ: 'Your parent\'s e-mail must be different from yours.',
        parent_email_required: 'Please enter your parent\'s or guardian\'s e-mail.',
        parental_consent_pending: 'Your account is waiting for your parent\'s approval.',
        waitingBody: 'We sent a link to {{email}}. Your account opens as soon as your parent approves it. Ask them to check their e-mail (and spam folder) within 7 days.',
        waitingTitle: 'Almost there!',
      },
    },
    invitedUserFlow: {
      loading: {
        validating: 'Validating invitation...',
        accepting: 'Accepting invitation...',
      },
      valid: {
        icon: 'checkmark',
        title: "You're Invited!",
        inviterText: 'has invited you to join',
        roleText: 'as a',
        acceptButton: 'Accept Invitation',
        declineButton: 'Decline',
      },
      invalid: {
        icon: 'error',
        title: 'Invalid Invitation',
        description: 'This invitation link is invalid or has expired. Please contact the person who invited you for a new invitation.',
        returnButton: 'Return to Home',
      },
      success: {
        message: 'Invitation accepted! Please sign in to continue.',
        type: 'success',
      },
    },
    auth: {
      login: 'Login',
      signup: 'Sign Up',
      forgotPassword: 'Forgot Password?',
      email: 'Email',
      password: 'Password',
      rememberMe: 'Remember me',
    },
    registration: {
      welcome: 'Welcome to AppAcademia',
      howToStart: 'How would you like to get started?',
      joinSchool: 'Join Existing School',
      joinSchoolDesc: 'You have an invitation code from your school',
      enterCode: 'Enter your invitation code',
      completeProfile: 'Complete your profile',
      startLearning: 'Start learning immediately',
      createSchool: 'Create New School',
      createSchoolDesc: 'Set up a new school organization',
      adminAccess: 'Admin access for your school',
      inviteUsers: 'Invite teachers and students',
      fullManagement: 'Full management capabilities',
      createYourSchool: 'Create Your School',
      setupInstitution: 'Set up your new educational institution',
      schoolName: 'School Name',
      enterSchoolName: 'Enter your school name',
      descriptionOptional: 'Description (Optional)',
      describeSchool: 'Describe your school',
      schoolType: 'School Type',
      selectSchoolType: 'Select school type',
      primary: 'Primary School',
      secondary: 'Secondary School',
      highSchool: 'High School',
      university: 'University',
      vocational: 'Vocational School',
      other: 'Other',
      country: 'Country',
      city: 'City',
      readyToComplete: 'Ready to Complete Registration',
      aboutToJoin: "You're about to join your school. Click submit to complete the process.",
      aboutToCreate: "You're about to create your new school. Click submit to get started.",
      completeRegistration: 'Complete Registration',
      stepType: 'Choose Type',
      stepCreate: 'Create School',
      stepJoin: 'Join School',
      stepAdmin: 'Admin Profile',
      stepProfile: 'Your Profile',
      stepComplete: 'Complete',
      joinYourSchool: 'Join Your School',
      enterInvitationCode: 'Enter your invitation code to get started',
      invitationCode: 'Invitation Code',
      invalidCode: 'Invalid or expired invitation code',
      validationFailed: 'Failed to validate invitation code',
      invitationValid: 'Invitation Valid!',
      school: 'School',
      role: 'Role',
      expires: 'Expires',
    },
    nav: {
      gradeEntryDesc: 'Grade entry',
      gradeHistoryDesc: 'Grade history',
      attendanceDesc: 'Attendance tracking',
      homeworkDesc: 'Homework & corrections',
      studentsDesc: 'Manage and track students',
      teachersDesc: 'Manage teachers and staff',
      payslipsDesc: 'Pay slips',
      teachingRecordDesc: 'Progression, cahier de textes and the term report for inspection',
      teacherCalendarDesc: 'Timetable',
      parentPortalDesc: 'Monitor your child\'s progress',
      parentHomeworkDesc: 'Your child\'s homework',
      parentAttendanceDesc: 'Attendance & absences',
      reportCardsDesc: 'School report cards',
      parentCommunicationDesc: 'Messages with school',
      userManagementDesc: 'User management & invitations',
      communicationDesc: 'Messages and announcements',
      settingsDesc: 'Application settings',
      pricingDesc: 'Plans & pricing',
      pricing: 'Plans & Pricing',
      upgrade: 'Upgrade',
      suivi: 'Pedagogical Follow-up',
      suiviDesc: 'Student behavior tracking and AI analysis',
      parentSuiviDesc: 'View your child\'s pedagogical follow-up',
      dashboardDesc: 'Overview and quick access',
      lessonsDesc: 'Interactive lessons and content',
      assessmentsDesc: 'Quizzes and assignments',
      examPrepDesc: 'AI-powered exam preparation',
      aiTutorDesc: '24/7 AI tutoring assistant',
      gamificationDesc: 'Achievements, badges & leaderboard',
      analyticsDesc: 'Track your learning progress',
      attendanceScannerDesc: 'QR code attendance scanner',
      cafeteriaDesc: 'Daily menu and cafeteria credits',
      emfPortalDesc: 'EMF payment collection portal',
      accountingDesc: 'Financial overview, reports & fee tracking',
      adminSetupDesc: 'Initial school setup and configuration',
      lessonPlannerDesc: 'Plan lessons with AI help',
      badge: { upgrade: 'Upgrade', AI: 'AI' },
    },
    parentAccess: {
      title: 'Parent access',
      codeLabel: 'Parent code',
      validity_one: 'For {{count}} parent, until {{date}}',
      validity_other: 'For {{count}} parents, until {{date}}',
      codeFailed: 'The code could not be created',
      howTo: 'Give this code to the parents: they sign up as a parent, choose "I received a code from my child\'s school" and enter it. They then see marks, report cards, absences and fees.',
      shareMessage: '{{school}}: follow {{child}} on AppAcademia. Sign up as a parent with the code {{code}}: {{link}}',
      copy: 'Copy the message',
      copied: 'Message copied',
      copyFailed: 'Could not copy',
      print: 'Print',
      printIntro: 'Follow {{child}} on AppAcademia',
      step1: 'Go to app.myappacademia.com/onboard',
      step2: 'Choose "I\'m a Parent", then "I received a code from my child\'s school"',
      step3: 'Enter this code and choose your password',
      byEmail: 'Or invite a parent by e-mail',
      send: 'Send',
      badEmail: 'Enter a valid e-mail address',
      invited: 'Invitation sent to {{email}}',
      invitedTo: 'Invitation sent to {{email}}',
      emailLinked: '{{email}} is linked to this pupil (invited by e-mail if new)',
      inviteFailed: 'The invitation could not be sent',
      enterCode: 'Do you have a parent code?',
      enterCodeHint: 'Your child\'s school gave it to you (paper, WhatsApp or SMS).',
      linkChild: 'Link my child',
      linked: 'Your child is linked to your account',
      invalidCode: 'This code is not valid or has been used. Ask the school for a new one.',
    },
    parentDashboard: {
      parentOf: 'parent of {{name}}',
      onlineLearning: "Online learning",
      onlineLearningDesc: "Lessons, AI tutor and exercises your child does in the app, outside class",
      rankOf: "Rank {{rank}}/{{size}}",
      noReportCardYet: "No report card yet",
      openReportCard: "See the report card",
      absencesLates: "{{absent}} absence(s) · {{late}} late",
      noRegisterYet: "No register taken yet",
      openAttendance: "See attendance",
      feesLeft: "Left to pay",
      nextDue: "Due {{date}}",
      allPaid: "All paid",
      openFees: "See fees and pay",
      latestMarks: "Latest marks",
      noMarksYet: "No marks yet this term",
      welcome: 'Welcome',
      parent: 'Parent',
      academicProgress: 'Academic Progress',
      lessonsCompleted: 'Lessons completed',
      masteryScore: 'Mastery Score',
      overallPerformance: 'Overall performance',
      attendance: 'Attendance',
      learningTime: 'Learning Time',
      totalStudyTime: 'Total study time',
      studyStreak: 'Study Streak',
      days: 'days',
      longest: 'Longest',
      performanceOverview: 'Performance Overview',
      detailedInsights: 'Detailed insights into academic progress',
      weeklyProgress: 'Weekly Progress',
      totalPoints: 'Total Points',
      classRank: 'Class Rank',
      lessonsDone: 'Lessons Done',
      studyTime: 'Study Time',
      viewDetailedReport: 'View Detailed Report',
      recentActivities: 'Recent Activities',
      activity: {
        mark: '{{subject}}: {{score}}',
        absent: '{{name}} was absent',
        late: '{{name}} arrived late',
        excused: '{{name}} was absent, excused',
        homework: 'Homework handed in: {{subject}}',
        homeworkMarked: 'Homework {{subject}}: {{score}}',
        lesson: 'Lesson finished: {{subject}}',
        practice: 'Exam practice: {{score}}',
      },
      feeStatuses: { pending: 'To pay', partial: 'Partial', paid: 'Paid', overdue: 'Overdue', cancelled: 'Cancelled', refunded: 'Refunded' },
      feeTotal: 'Total',
      feePaid: 'Paid',
      feeBalance: 'Balance',
      feeDue: 'Due',
      feeInstallments_one: '{{count}} installment allowed',
      feeInstallments_other: '{{count}} installments allowed',
      feePayments_one: '{{count}} payment recorded',
      feePayments_other: '{{count}} payments recorded',
      payMethods: { cash: 'cash', bank_transfer: 'bank transfer', mobile_money: 'Mobile Money', mtn_momo: 'MTN MoMo', orange_money: 'Orange Money', wave: 'Wave', express_union: 'Express Union', card: 'card', cheque: 'cheque', online: 'online' },
      termAverage: 'Term average',
      noRecentActivities: 'No recent activities',
      upcomingEvents: 'Upcoming Events',
      noUpcomingEvents: 'No upcoming events',
      selectChild: 'Select Child',
      notifications: 'Notifications',
      viewAllNotifications: 'View All Notifications',
      noNewNotifications: 'No new notifications',
      schoolFees: 'School Fees',
      feeStatus: 'Fee status for your children',
      noFeesAssigned: 'No fees assigned yet',
      quickActions: 'Quick Actions',
      scheduleMeeting: 'Schedule Meeting',
      viewReportCards: 'View Report Cards',
      contactTeachers: 'Contact Teachers',
      parentTips: 'Parent Tips',
      encouragePractice: 'Encourage Daily Practice',
      encouragePracticeDesc: 'Help maintain study streaks by setting regular study times',
      celebrateAchievements: 'Celebrate Achievements',
      celebrateAchievementsDesc: 'Acknowledge progress to boost motivation',
    },
    parentHome: {
      paymentDeclared: "Payment declared",
      declarationPending: "{{amount}} declared — being checked by the school",
      declarationRejected: "{{amount}} not found by the school",
      example: "e.g.",
      examPrep: {
        sessions: 'Practice sessions',
        lastScore: 'Last score',
        dueCards: 'Cards to review',
        weakAreas: 'To work on',
        noPaper: 'No past paper uploaded yet',
      },
      noUpcomingMenu: 'No menu available for the upcoming days',
      selectChildForFees: 'Select a child to view school fees',
      noFeesPending: 'No fees pending',
      schoolFees: 'School Fees',
      fee: 'Fee',
      paid: 'Paid',
      partial: 'Partial',
      pending: 'Pending',
      noTransportInfo: 'No transport information available',
      noTransportRoutes: 'No transport routes available',
      reportCards: 'Report Cards',
      fees: 'Fees',
      myChildren: 'My children',
      myChild: 'My child',
      noChildLinked: 'No child linked to your account.',
      contactAdmin: 'Contact your school administration to link your account.',
      noNotifications: 'No notifications',
      submitted: 'Submitted',
      late: 'Late',
      toDo: 'To do',
      noHomework: 'No current homework',
      excused: 'Excused',
      unexcused: 'Unexcused',
      noRecentAbsences: 'No recent absences',
      reportCardsFor: 'Report cards for',
      yourChild: 'your child',
      recentGrades: 'Recent grades',
      noRecentGrades: 'No recent grades',
      upcomingAppointments: 'Upcoming appointments',
      noUpcomingAppointments: 'No upcoming appointments',
      contactTeacherForAppointment: 'Contact a teacher or the administration to schedule a meeting.',
      viewReportCardsPDF: 'View report cards PDF',
      suivi: 'Follow-up',
    },
    parentSuivi: {
      title: 'Pedagogical Follow-up',
      subtitle: 'View observations and AI analysis for your child',
      selectChild: 'Select a child',
      selectChildDesc: 'Please select a child from the top of the page to view their pedagogical follow-up.',
      analyzing: 'Analyzing...',
      aiAnalysis: 'AI Analysis',
      aiSummary: 'AI Assessment',
      riskLevel: 'Risk Level',
      guidanceForYou: 'Guidance for You',
      patterns: 'Observed Patterns',
      suggestions: 'Recommendations',
      observations: 'Teacher Observations',
      noObservations: 'No observations recorded yet.',
      strengths: 'Strengths',
      areasToImprove: 'Areas to improve',
      actionPlan: 'Action plan',
    },
    timetable: {
      addSlot: 'Add slot',
      day: 'Day',
      deleteSlotConfirm: 'Are you sure you want to delete the "{{subject}}" slot? This action cannot be undone.',
      deleteSlotTitle: 'Delete timetable slot',
      editSlot: 'Edit Timetable Slot',
      endTime: 'End time',
      errorCreating: 'Failed to create slot',
      errorDeleting: 'Failed to delete slot',
      errorUpdating: 'Failed to update slot',
      friday: 'Fri',
      hour: 'Hour',
      monday: 'Mon',
      newSlot: 'New Timetable Slot',
      room: 'Room',
      saturday: 'Sat',
      selectClass: 'Select a class',
      selectClassPrompt: 'Select a class to view the timetable',
      selectSubject: 'Subject',
      slotCreated: 'Slot created successfully',
      slotDeleted: 'Slot deleted successfully',
      slotUpdated: 'Slot updated successfully',
      startTime: 'Start time',
      thursday: 'Thu',
      tuesday: 'Tue',
      wednesday: 'Wed',
    },
    homework: {
      types: {
        homework: 'Homework',
        exercise: 'Exercise',
        project: 'Project',
        reading: 'Reading',
        revision: 'Revision',
        test: 'Test',
        research: 'Research',
      },
      allClasses: 'All classes',
      assignments: 'Assignments',
      average: 'Average',
      class: 'Class',
      create: 'Create',
      createSuccess: 'Assignment created successfully',
      deleteConfirm: 'Delete this assignment?',
      description: 'Description',
      descriptionPlaceholder: 'Instructions for students...',
      dueDateLabel: 'Due date *',
      dueDateRequired: 'Due date is required',
      editAssignment: 'Edit assignment',
      feedback: 'Feedback',
      feedbackPlaceholder: 'Feedback...',
      grade: 'Grade',
      graded: 'Graded',
      grading: 'Grading',
      loadFailed: 'Failed to load assignments. Please retry',
      maxScore: 'Max score',
      newAssignment: 'New assignment',
      noAssignments: 'No assignments yet',
      notSubmitted: 'Not submitted',
      saveAll: 'Save all',
      saveFailed: 'Save failed. Please try again.',
      score: 'Score',
      selectAssignment: 'Select an assignment from the Assignments tab',
      status: 'Status',
      student: 'Student',
      subject: 'Subject',
      submitted: 'submitted',
      titleLabel: 'Title *',
      titlePlaceholder: 'e.g., Exercises page 45',
      titleRequired: 'Title is required',
      totalStudents: 'Total students',
      updateSuccess: 'Assignment updated successfully',
    },
    leaveRequest: {
      approve: 'Approve',
      approved: 'Approved',
      noRequests: 'No requests',
      pending: 'Pending',
      reject: 'Reject',
      rejected: 'Rejected',
      rejectionReason: 'Reason for rejection...',
      requestedBy: 'Requested by',
      subtitle: 'Manage absence requests from parents',
      title: 'Leave requests',
    },
    schoolAnalytics: {
      absences: 'absences',
      absencesLabel: 'Absences',
      allTrimesters: 'All trimesters',
      attendanceRate: 'Attendance Rate',
      attendanceSummary: 'Attendance Summary',
      average: 'Average',
      bestClass: 'Best class',
      boys: 'Boys',
      chooseClass: 'Choose a class...',
      class: 'Class',
      classAverage: 'Class Average',
      classDetail: 'Class Detail',
      classPerformance: 'Class Performance',
      classes: 'Classes',
      conduct: 'Conduct',
      currentYear: 'Current year',
      decision: 'Decision',
      exportError: 'Export failed',
      failed: 'Failed',
      gender: 'Gender',
      genderBreakdown: 'Gender Breakdown',
      girls: 'Girls',
      justifiedAbsences: 'Justified absences',
      lates: 'Lates',
      loadError: 'Error loading statistics',
      loading: 'Loading statistics...',
      minimum: 'Min',
      maximum: 'Max',
      needsSupport: 'Needs support',
      noClasses: 'No classes with report cards',
      noData: 'No data available',
      noStudents: 'No students',
      noSubjectData: 'No subject data available for this period',
      outOf20: 'out of 20',
      overview: 'Overview',
      parityIndex: 'Parity index',
      passRate: 'Pass Rate',
      passed: 'Passed',
      pendingLeave: 'pending leave request(s)',
      procesVerbal: 'P.V.',
      rank: 'Rank',
      rate: 'Rate',
      schoolAverage: 'School Average',
      selectClass: 'Select class',
      selectClassPrompt: 'Select a class to view student details',
      selectTrimester: 'Please select a trimester for the Procès-verbal',
      studentName: 'Name',
      students: 'Students',
      subject: 'Subject',
      subjectAverages: 'Subject Averages',
      subjectRanking: 'Subject Performance Ranking',
      subjects: 'Subjects',
      top: 'Top',
      totalRecords: 'Total records',
      totalStudents: 'Total Students',
    },
    teachers: {
      confirmDeactivate: 'Are you sure you want to deactivate this teacher?',
      deactivateTitle: 'Deactivate Teacher',
      title: 'Teachers Management',
      subtitle: 'Manage your teaching staff, track performance, and assign resources',
      fetchFailed: 'Failed to fetch teachers',
      deactivated: 'Teacher deactivated successfully',
      deactivateFailed: 'Failed to deactivate teacher',
      activated: 'Teacher activated successfully',
      activateFailed: 'Failed to activate teacher',
      noGrades: 'No grades assigned',
      addTeacher: 'Add Teacher',
      totalTeachers: 'Total Teachers',
      growthRate: '+12% from last month',
      activeTeachers: 'Active Teachers',
      activeRate: '95.5% active rate',
      avgRating: 'Avg. Rating',
      fromReviews: 'From 2,345 reviews',
      totalLessons: 'Total Lessons',
      avgPerTeacher: '19.4 avg per teacher',
      searchPlaceholder: 'Search teachers by name or email...',
      allSubjects: 'All Subjects',
      allGrades: 'All Grades',
      grade: 'Grade',
      nameAZ: 'Name (A-Z)',
      nameZA: 'Name (Z-A)',
      newestFirst: 'Newest First',
      oldestFirst: 'Oldest First',
      mostExperienced: 'Most Experienced',
      leastExperienced: 'Least Experienced',
      loading: 'Loading teachers...',
      noTeachers: 'No teachers found',
      teacher: 'Teacher',
      subjects: 'Subjects',
      gradeLevels: 'Grade Levels',
      experience: 'Experience',
      students: 'Students',
      rating: 'Rating',
      years: 'years',
      showingPage: 'Showing page {{current}} of {{total}}',
      importStarted: 'Import started',
      processing: 'Processing {{name}}...',
      addNewTeacher: 'Add New Teacher',
      editTeacher: 'Edit Teacher',
      basicInfo: 'Basic Information',
      fullName: 'Full Name',
      email: 'Email',
      password: 'Password',
      yearsOfExperience: 'Years of Experience',
      teachingProfile: 'Teaching Profile',
      teachingStyle: 'Teaching Style',
      selectTeachingStyle: 'Select teaching style',
      styleTraditional: 'Traditional',
      styleCollaborative: 'Collaborative',
      styleTechnologyfocused: 'Technology-focused',
      styleProjectbased: 'Project-based',
      styleInquirybased: 'Inquiry-based',
      styleFlippedclassroom: 'Flipped classroom',
      certifications: 'Certifications',
      certificationsPlaceholder: 'e.g., State Teaching License, M.Ed., National Board Certification',
      specializations: 'Specializations',
      specializationsPlaceholder: 'e.g., Special Education, Gifted Education, ESL',
      professionalGoals: 'Professional Goals',
      professionalGoalsPlaceholder: 'Describe professional development goals...',
      updateTeacher: 'Update Teacher',
      updated: 'Teacher updated successfully',
      created: 'Teacher created successfully',
      saveFailed: 'Failed to save teacher',
      teachingDetails: 'Teaching Details',
      totalStudents: 'Total Students',
      editProfile: 'Edit Profile',
      tabOverview: 'Overview',
      tabPerformance: 'Performance',
      tabSchedule: 'Schedule',
      tabResources: 'Resources',
      yearsExperience: 'years experience',
      studentProgress: 'Student Progress',
      avgImprovement: 'Avg. Improvement',
      aboveTarget: 'Above Target',
      atRisk: 'At Risk',
      engagementMetrics: 'Engagement Metrics',
      lessonCompletion: 'Lesson Completion',
      assignmentSubmission: 'Assignment Submission',
      avgTimePerLesson: 'Avg. Time per Lesson',
      feedbackRatings: 'Feedback & Ratings',
      studentRating: 'Student Rating',
      parentSatisfaction: 'Parent Satisfaction',
      basedOnReviews: 'Based on {{count}} reviews',
      noPerformanceData: 'No performance data available',
      loadingPerformance: 'Loading performance data...',
      weeklySchedule: 'Weekly Schedule',
      noSchedule: 'No schedule set',
      noScheduleDescription: 'The timetable for this teacher has not been configured yet.',
      teachingResources: 'Teaching Resources',
      noResources: 'No resources yet',
      noResourcesDescription: 'Lessons and materials created by this teacher will appear here.',
    },
    subjects: {
      mathematics: 'Mathematics',
      science: 'Science',
      english: 'English',
      history: 'History',
      geography: 'Geography',
      physics: 'Physics',
      chemistry: 'Chemistry',
      biology: 'Biology',
      computerscience: 'Computer Science',
      art: 'Art',
      music: 'Music',
      physicaleducation: 'Physical Education',
      foreignlanguage: 'Foreign Language',
      socialstudies: 'Social Studies',
    },
    cafeteria: {
      menu: 'Menu',
      credits: 'Credits',
      history: 'History',
      menuFor: 'Menu for',
      publishNotify: 'Publish & Notify Parents',
      published: 'Menu published',
      parentsNotified: '{{count}} parents notified',
      addItem: 'Add Item',
      itemName: 'Item name',
      price: 'Price',
      description: 'Description (optional)',
      allergens: 'Allergens (optional)',
      breakfast: 'Breakfast',
      lunch: 'Lunch',
      snack: 'Snack',
      beverage: 'Beverage',
      noMenu: 'No menu items for today',
      checkBalance: 'Check Balance',
      selectStudent: 'Select a student',
      check: 'Check',
      topUp: 'Top Up Credit',
      amount: 'Amount (FCFA)',
      addCredit: 'Add Credit',
      transactionHistory: 'Transaction History',
      load: 'Load',
      noTransactions: 'No transactions found',
      title: 'Cafeteria',
      subtitle: 'Menu management and student credits',
      todayMenu: "Today's Menu",
      failedToPublish: 'Failed to publish',
      itemCreated: 'Menu item created',
      deleted: 'Deleted',
      failedToDelete: 'Failed to delete',
      creditToppedUp: 'Credit topped up',
      studentNotFound: 'Student not found',
      orders: 'Orders',
      scanAndOrder: 'Scan & Order',
      scanAndOrderDesc: 'Scan student QR code and select items to purchase',
      scanQR: 'Scan QR',
      searchStudent: 'Search student by name or ID...',
      searchOrScan: 'Search student or scan QR...',
      student: 'Student',
      currentBalance: 'Current Balance',
      selectItems: 'Select items to order',
      noMenuToday: 'No menu items available today',
      totalItems: 'Total items',
      insufficientBalance: 'Insufficient balance for this order',
      confirmOrder: 'Confirm Order',
      orderComplete: 'Order Complete',
      orderSummary: 'Remaining balance: {{balance}} FCFA',
      orderFailed: 'Order failed',
      imageUrl: 'Image URL (optional)',
      uploadImage: 'Click to upload food image',
      imageTooLarge: 'Image must be under 5 MB',
      parentSubtitle: 'View daily menu and meal prices',
      recentOrders: 'Recent Orders',
      orderReceipt: 'Order Receipt',
      newOrder: 'New Order',
      orderTotal: 'Total',
      paidAt: 'Paid at',
      noRecentOrders: 'No recent orders for this student',
      scanStudent: 'Scan Student',
      scanInstructions: 'Scan QR code or type student ID',
      scanPlaceholder: 'Student ID or QR code...',
      findStudent: 'Find Student',
    },
    support: {
      welcome: "Hello! 👋 I'm **Aya**, your AppAcademia support assistant. I can help with:\n\n• 📚 Feature guides & how-to\n• 🔧 Troubleshooting\n• 💳 Subscription & payments\n• 🏫 School setup\n• 🤖 AI features\n\nHow can I help you today?",
      openChat: 'Open support chat',
      typing: 'Typing...',
      online: 'Support Assistant',
      newChat: 'New conversation',
      history: 'Chat history',
      feedback: 'Rate support',
      previousChats: 'Previous Chats',
      noHistory: 'No previous conversations',
      rateExperience: 'How was your experience?',
      placeholder: 'Ask Aya anything...',
      quickHow: 'How do I get started?',
      quickPricing: 'View plans & pricing',
      quickSchool: 'Set up my school',
      quickAI: 'AI tutor help',
      quickParent: 'Parent features',
      quickTrouble: 'Troubleshooting',
      quickHowMsg: 'How do I get started with AppAcademia?',
      quickPricingMsg: 'What plans and pricing do you offer?',
      quickSchoolMsg: 'How do I set up my school on AppAcademia?',
      quickAIMsg: 'How does the AI tutor work?',
      quickParentMsg: 'What can parents do on the platform?',
      quickTroubleMsg: 'I\'m having a technical issue',
      errorFallback: 'Sorry, something went wrong. Please try again.',
      minimizedLabel: 'Aya — Support',
    },
    paymentMethods: {
      mtnMomo: 'MTN MoMo',
      orangeMoney: 'Orange Money',
      wave: 'Wave',
      expressUnion: 'Express Union',
      bankTransfer: 'Bank Transfer',
      cash: 'Cash',
    },
    accounting: {
      title: 'Accounting',
      subtitle: 'Financial overview and reporting',
      totalExpected: 'Total Expected',
      totalCollected: 'Total Collected',
      outstanding: 'Outstanding',
      collectionRate: 'Collection Rate',
      studentStatus: 'Student Status',
      fullyPaid: 'Fully Paid',
      withBalance: 'With Balance',
      overdue: 'Overdue',
      monthlyRevenue: 'Monthly Revenue',
      paymentMethods: 'Payment Methods',
      categoryBreakdown: 'Fee Category Breakdown',
      category: 'Category',
      expected: 'Expected',
      collected: 'Collected',
      remaining: 'Remaining',
      rate: 'Rate',
      recentPayments: 'Recent Payments',
      date: 'Date',
      reference: 'Reference',
      amount: 'Amount',
      method: 'Method',
      receipt: 'Receipt',
      exportReport: 'Export Report',
      recordPayment: 'Record Payment',
      generateInvoice: 'Generate Invoice',
      sendReminders: 'Send Reminders',
      noData: 'No accounting data available yet',
      quickActions: 'Quick Actions',
      allYears: 'All Years',
      exportCSV: 'Export CSV',
      exportFailed: 'Export failed',
      payrollExpenses: 'Payroll & Expenses',
      teachers: 'Teachers',
      baseSalaries: 'Base Salaries',
      bonuses: 'Bonuses',
      netPayroll: 'Net Payroll',
      revenueVsExpenses: 'Revenue vs Expenses',
      netBalance: 'Net',
      revenue: 'Revenue',
      expenses: 'Expenses',
      classBreakdown: 'Class-Level Summary',
      className: 'Class',
      students: 'Students',
      bulkAssign: 'Bulk Fee Assignment',
      assignToClass: 'Assign to Class',
      selectClass: 'Select class...',
      selectFee: 'Select fee structure...',
      assignToAllStudents: 'Assign to All Students in Class',
      bulkAssigned: 'Fees Assigned',
      bulkAssignedDesc: '{{assigned}} assigned, {{skipped}} skipped',
      allAlreadyAssigned: 'Already Assigned',
      allStudentsHaveFee: 'All {{total}} students in this class already have this fee assigned.',
      exportStatement: 'Export Statement',
      studentStatement: 'Account Statement',
      paymentReceipt: 'Payment Receipt',
      classReport: 'Class Report',
      payrollReport: 'Payroll Report',
      exportClassReport: 'Export Class Report',
      exportPayroll: 'Export Payroll',
      printReceipt: 'Print Receipt',
      generatedBy: 'Generated by AppAcademia',
      totalFees: 'Total Fees',
      totalPaid: 'Total Paid',
      remainingBalance: 'Remaining Balance',
      filterByClass: 'Filter by class',
      allClasses: 'All Classes',
      noClassData: 'Select a class to export its report',
      paymentHistory: 'Payment History',
      feeBreakdown: 'Fee Breakdown',
      statementFor: 'Statement for',
      receiptFor: 'Receipt for',
      classFilterActive: 'Showing {{count}} students in {{className}}',
    },
    payroll: {
      configurePayroll: 'Configure Payroll',
      taxRate: 'Tax Rate (%)',
      socialSecurity: 'Social Security (%)',
      pensionRate: 'Pension Rate (%)',
      payDay: 'Pay Day',
      currency: 'Currency',
      save: 'Save',
      editSalary: 'Edit Salary',
      setTeacherSalary: 'Set Teacher Salary',
      selectTeacher: 'Select Teacher',
      searchTeacher: 'Search teacher by name...',
      noTeacherFound: 'No teacher found',
      teacherId: 'Teacher ID',
      teacherIdPlaceholder: 'e.g.: teacher-uuid',
      baseSalary: 'Base Salary (XAF)',
      transportAllowance: 'Transport Allowance (XAF)',
      housingAllowance: 'Housing Allowance (XAF)',
      otherAllowances: 'Other Allowances (XAF)',
      estimatedGross: 'Estimated Gross',
      update: 'Update',
      generatePaySlipsTitle: 'Generate Pay Slips',
      month: 'Month',
      year: 'Year',
      generateWarning: 'Pay slips will be generated for all teachers with a configured salary. Statutory deductions will be calculated automatically.',
      generateFor: 'Generate for {{month}} {{year}}',
      totalPayroll: 'Total Payroll',
      teachers: 'Teachers',
      pending: 'Pending',
      paidSlips: 'Paid Slips',
      configure: 'Configure',
      teacherSalary: 'Teacher Salary',
      exportCSV: 'Export CSV',
      generatePayslips: 'Generate Pay Slips',
      salaries: 'Salaries',
      paySlips: 'Pay Slips',
      attendanceHours: 'Attendance Hours',
      draft: 'Draft',
      approved: 'Approved',
      paid: 'Paid',
      errorLoadSummary: 'Failed to load payroll summary',
      errorLoadSalaries: 'Failed to load salaries',
      payslipPaid: 'Pay slip marked as paid',
      payFailed: 'Failed to mark as paid',
      noPayslipsExport: 'No pay slips to export',
      teacher: 'Teacher',
      grossSalary: 'Gross Salary',
      deductions: 'Deductions',
      netSalary: 'Net Salary',
      status: 'Status',
      exportSuccess: '{{count}} pay slips exported to CSV',
      noSchool: 'No school found',
      noSalaries: 'No salaries configured',
      noSalariesHint: 'Use "Teacher Salary" to get started.',
      base: 'Base',
      transport: 'Transport',
      housing: 'Housing',
      other: 'Other',
      gross: 'Gross',
      net: 'Net',
      action: 'Action',
      edit: 'Edit',
      noPayslips: 'No pay slips generated',
      noPayslipsHint: 'Click "Generate Pay Slips" to get started.',
      period: 'Period',
      actions: 'Actions',
      approve: 'Approve',
      markPaid: 'Mark as paid',
      deductionDetails: 'Deduction Details',
      tax: 'Tax',
      pension: 'Pension',
      noAttendanceData: 'No attendance data for this period',
      attendanceRate: 'Attendance Rate',
      employee: 'Employee',
      role: 'Role',
      daysPresent: 'Days Present',
      absences: 'Absences',
      lateArrivals: 'Late Arrivals',
      hoursWorked: 'Hours Worked',
      overtime: 'Overtime',
    },
    sms: {
      channelSms: 'SMS',
      channelWhatsapp: 'WhatsApp',
      channelEmail: 'Email',
      compose: 'Compose',
      templates: 'Templates',
      history: 'History',
      trigger_manual: 'Manual',
      trigger_attendance: 'Attendance',
      trigger_grade_published: 'Grade Published',
      trigger_fee_reminder: 'Fee Reminder',
      trigger_event: 'Event',
      status_queued: 'Queued',
      status_sent: 'Sent',
      status_delivered: 'Delivered',
      status_failed: 'Failed',
      role_students: 'Students',
      role_teachers: 'Teachers',
      role_parents: 'Parents',
      totalSent: 'Total Sent',
      delivered: 'Delivered',
      failed: 'Failed',
      templatesCount: 'Templates',
      composeMessage: 'Compose Message',
      channel: 'Channel',
      recipients: 'Recipients',
      searchRecipient: 'Search by name, email, or phone...',
      message: 'Message',
      typeMessageHere: 'Type your message here...',
      placeholderHint: 'Use {student_name}, {school_name}, {date} as placeholders',
      send: 'Send',
      sending: 'Sending...',
      sendMessage: 'Send Message',
      newTemplate: 'New Template',
      editTemplate: 'Edit Template',
      broadcast: 'Broadcast',
      broadcastMessage: 'Broadcast Message',
      broadcastPlaceholder: 'Enter broadcast message...',
      sendBroadcast: 'Send Broadcast',
      targetAudience: 'Target Audience',
      templateName: 'Template Name',
      templateNamePlaceholder: 'e.g. Attendance Alert',
      content: 'Content',
      contentPlaceholder: 'Dear {student_name}, your attendance on {date}...',
      trigger: 'Trigger',
      cancel: 'Cancel',
      close: 'Close',
      saving: 'Saving...',
      saveTemplate: 'Save Template',
      createTemplate: 'Create Template',
      searchTemplates: 'Search templates...',
      noTemplates: 'No templates yet',
      createFirstTemplate: 'Create your first message template',
      searchMessages: 'Search messages...',
      noMessagesSent: 'No messages sent yet',
      historyAppearHere: 'Your notification history will appear here',
      date: 'Date',
      recipient: 'Recipient',
      status: 'Status',
      use: 'Use',
      edit: 'Edit',
      loadError: 'Failed to load notification data',
      error: 'Error',
      success: 'Success',
      sentSuccess: 'Message sent successfully!',
      sendError: 'Failed to send message',
      templateUpdated: 'Template updated!',
      templateCreated: 'Template created!',
      templateSaveError: 'Failed to save template',
      broadcastSuccess: 'Broadcast sent successfully!',
      broadcastError: 'Failed to send broadcast',
      templateLoaded: 'Template "{{name}}" loaded',
    },
    loginPage: {
      title: 'Welcome back',
      subtitle: 'Sign in to your account',
      emailLabel: "Email or username",
      emailPlaceholder: 'your.email@example.com',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password',
      signIn: 'Sign In',
      signingIn: 'Signing in…',
      continueWithGoogle: 'Continue with Google',
      or: 'or',
      newToApp: 'New to AppAcademia?',
      schoolAdmin: 'I manage a school',
      schoolAdminDesc: 'Register your school and manage everything',
      teacherOrParent: 'I\'m a Teacher or Parent',
      teacherOrParentDesc: 'Join independently or connect with a school',
      student: 'I\'m a Student',
      studentDesc: 'Start learning in 60 seconds',
      haveJoinCode: 'Received a code from your school?',
      joinWithCode: 'Join with school code',
      needVerification: 'Need to verify your email?',
      sendVerification: 'Send Verification Email',
      dataSecure: 'Your data is secure and encrypted',
      networkError: 'Network error. Please check your connection.',
      loginFailed: 'Login failed. Please check your credentials.',
      tooManyAttempts: 'Too many wrong passwords for this account. Wait 15 minutes, or use "Forgot password?".',
      googleFailed: 'Google sign-in failed. Please try email login.',
      verificationRequired: 'Email verification required. Please verify your email to continue.',
      forgotPassword: 'Forgot your password?',
      welcomeBack: "Welcome back",
      heroHeadline: "Your whole school, intelligently connected.",
      heroSubtitle: "AI tutoring, exam prep, attendance, payments and parent communication — one secure platform for every role.",
      heroFeatures: "Features",
      heroRoles: "Roles",
      heroUptime: "Uptime",
      heroCompliance: "GDPR · FERPA · COPPA · WCAG 2.2 AA compliant",
      verificationEmailFailed: "Failed to send verification email.",
      googleNoAccount: 'No account uses this Google address yet. Create one first from the sign-up page.',
      parentalConsentPending: 'Your account is waiting for your parent\'s approval. Ask them to open the link we e-mailed them.',
    },
    forgotPassword: {
      title: 'Reset your password',
      subtitle: 'Enter your email and we\'ll send you a reset link',
      emailLabel: 'Email address',
      sendReset: 'Send reset link',
      sending: 'Sending...',
      checkEmail: 'Check your email!',
      checkEmailDesc: 'We\'ve sent a password reset link to your email address. Check your inbox and spam folder.',
      backToLogin: 'Back to login',
      emailRequired: 'Please enter your email address',
      sendFailed: 'Failed to send reset link',
    },
    resetPassword: {
      title: 'Create new password',
      subtitle: 'Enter your new password below',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      resetButton: 'Reset password',
      resetting: 'Resetting...',
      success: 'Password reset successfully!',
      successDesc: 'You can now log in with your new password. Redirecting...',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 8 characters',
      invalidToken: 'Invalid or expired reset link. Please request a new one.',
      strength: {
        weak: 'Weak',
        medium: 'Medium',
        strong: 'Strong',
      },
      resetFailed: 'Failed to reset password',
    },
    dashboard: {
      title: 'Dashboard',
      welcomeTitle: '🎉 Welcome to AppAcademia!',
      welcomeDescription: 'Successfully logged in as {{email}}. Start your learning journey!',
      overview: 'Overview',
      recentActivity: 'Recent Activity',
      upcomingLessons: 'Upcoming Lessons',
      performance: 'Performance',
      greeting: 'Welcome back, {{name}}!',
      streakMessage: "You're on a {{days}} day learning streak! Keep it up! 🔥",
      noDataAvailable: 'No dashboard data available',
      lessonsCompleted: 'Lessons Completed',
      totalLessons: 'total lessons',
      currentStreak: 'Current Streak',
      days: 'days',
      masteryScore: 'Mastery Score',
      weeklyProgress: 'Weekly Progress',
      studyGoals: 'Study Goals',
      completeToday: 'Complete today\'s lessons',
      practiceAssessment: 'Practice assessment',
      reviewNotes: 'Review notes',
      learningPathway: 'Learning Pathway',
      progress: 'Progress',
      currentTopic: 'Current Topic',
      nextMilestone: 'Next Milestone',
      estimatedTime: 'Estimated Time',
      continuePathway: 'Continue Pathway',
      quickActions: 'Quick Actions',
      startLesson: 'Start Lesson',
      practiceQuiz: 'Practice Quiz',
      askTutor: 'Ask AI Tutor',
      viewAll: 'View All',
      error: 'Error',
      failedToLoad: 'Failed to load dashboard data',
      learningStreak: 'Learning Streak',
      lessonsToGo: '{{count}} lessons to go',
      keepLearning: 'Keep learning daily to maintain your streak!',
      greatJob: 'Great job this week!',
      yourLearningPathway: 'Your Learning Pathway',
      continuePersonalized: 'Continue your personalized learning journey',
      continueLearning: 'Continue Learning',
      practiceMode: 'Practice Mode',
      scheduleStudyTime: 'Schedule Study Time',
      viewAllAchievements: 'View All Achievements',
      percentageIncrease: '+{{percent}}% from last week',
      achievements: 'Achievements',
      achievementsDescription: 'Your learning milestones',
      upcomingLessonsDescription: 'Your scheduled learning activities for today',
      recentActivityDescription: 'Your learning journey milestones',
      mandatory: 'Mandatory',
      join: 'Join',
      start: 'Start',
      min: 'min',
      complete: '{{percent}}% complete',
    },
    spreadsheet: {
      col_full_name: 'Full name',
      col_matricule: 'Student ID',
      col_gender: 'Sex',
      col_date_of_birth: 'Date of birth',
      col_birthplace: 'Place of birth',
      col_parent_email: 'Parent email',
      col_emergency_contact: 'Emergency contact',
    },
    adminDashboard: {
      home: {
        morning: 'Good morning',
        afternoon: 'Good afternoon',
        evening: 'Good evening',
        students: 'Students',
        parentsLinked_one: '{{count}} parent linked',
        parentsLinked_other: '{{count}} parents linked',
        attendance: 'Attendance',
        absencesLogged_one: '{{count}} absence logged',
        absencesLogged_other: '{{count}} absences logged',
        noRecords: 'No records yet',
        feesCollected: 'Fees collected',
        collected: '{{amount}} collected',
        noFees: 'No fees set up',
        teachers: 'Teachers',
        classesCount_one: '{{count}} class',
        classesCount_other: '{{count}} classes',
        briefCounts: '{{students}} students and {{teachers}} teachers across {{classes}} classes.',
        briefArrears_one: '{{count}} family has outstanding fees ({{amount}}).',
        briefArrears_other: '{{count}} families have outstanding fees ({{amount}}).',
        briefLeave_one: '{{count}} leave request awaits review.',
        briefLeave_other: '{{count}} leave requests await review.',
        briefInvites_one: '{{count}} invited member has not joined yet.',
        briefInvites_other: '{{count}} invited members have not joined yet.',
        taskLeave_one: '{{count}} leave request pending',
        taskLeave_other: '{{count}} leave requests pending',
        taskLeaveDetail: 'Staff time-off awaiting your decision',
        taskArrears_one: '{{count}} student with fee arrears',
        taskArrears_other: '{{count}} students with fee arrears',
        outstanding: '{{amount}} outstanding',
        taskInvites_one: '{{count}} pending invitation',
        taskInvites_other: '{{count}} pending invitations',
        taskInvitesDetail: 'Invited members have not joined',
        firstSteps: 'First steps',
        stepsDone: '{{done}}/{{total}} done',
        stepClasses: 'Create your classes',
        stepPupils: 'Add your pupils',
        stepTeachers: 'Invite your teachers',
        stepFees: 'Set the school fees',
        stepRegister: 'Take the first register',
        present: 'Present',
        absent: 'Absent',
        late: 'Late',
        justified: 'Justified',
        loadError: 'Dashboard data could not be loaded. Showing the latest available figures.',
        retry: 'Retry',
        reports: 'Reports',
        addStudent: 'Add student',
        glance: 'School at a glance',
        needsYou: 'Needs you',
        open_one: '{{count}} open',
        open_other: '{{count}} open',
        allCaughtUp: "You're all caught up — nothing needs your attention.",
        familiesArrears_one: '{{count}} family in arrears',
        familiesArrears_other: '{{count}} families in arrears',
        noArrears: 'No overdue fees',
        toCollect: '{{amount}} still to collect',
        allCollected: 'Everything billed is collected.',
        nothingToApprove: 'Nothing to approve.',
        openFinance: 'Open finance',
        attendanceRate: '{{rate}}% attendance',
        noAttendance: 'No attendance yet',
        absencesLates: '{{absences}} absences · {{lates}} late',
        openAttendance: 'Open attendance',
        leaveCount_one: '{{count}} leave request',
        leaveCount_other: '{{count}} leave requests',
        noLeave: 'No leave requests',
        awaitingApproval: 'Awaiting your approval.',
        reviewLeave: 'Review leave',
        attendanceBreakdown: 'Attendance breakdown',
        noAttendanceRecorded: 'No attendance has been recorded yet.',
        studentFees: 'Student fees',
        noStudentFees: 'No student fees recorded yet.',
        fee: 'Fee',
      },
      title: 'Admin Dashboard',
      error: 'Error',
      failedToLoadDashboard: 'Failed to load dashboard data',
      noDashboardData: 'No dashboard data available',
      totalUsers: 'Total Users',
      classrooms: 'Classrooms',
      activeClassrooms: 'Active classrooms',
      teachers: 'Teachers',
      educationalStaff: 'Educational staff',
      students: 'Students',
      activeLearners: 'Active learners',
      parents: 'Parents',
      registeredParents: 'Registered parents',
      activeToday: 'Active Today',
      usersOnline: 'Users online',
      newThisWeek: 'New This Week',
      newRegistrations: 'New registrations',
      lessons: 'Lessons',
      totalLessons: 'Total lessons created',
      assessments: 'Assessments',
      totalAssessments: 'Total assessments',
      subjects: 'Subjects',
      subjectsTaught: 'Subjects taught',
      pendingInvitations: 'Pending Invitations',
      awaitingResponse: 'Awaiting response',
      userGrowth: 'New Registrations',
      userGrowthDescription: 'Daily new user registrations over the last 30 days',
      notifications: 'Notifications',
      noActiveAlerts: 'No notifications',
      recentActivity: 'Recent Activity',
      noRecentActivity: 'No recent activity',
      setupSchool: 'Set up your school to start managing classes, teachers, and students.',
      completeSetup: 'Complete School Setup',
      completeSetupDescription: 'Set up your school year, classrooms, subjects, and invite teachers to start seeing activity data here.',
      goToSetup: 'Go to School Setup',
      noGrowthData: 'No user registration data yet. The chart will appear once users start joining your school.',
    },
    teacher: {
      welcome: 'Welcome back, {{name}}',
      pendingReviewsAndClasses: 'You have {{reviews}} pending reviews and {{classes}} upcoming classes today.',
      activeStudents: 'Active Students',
      totalStudents: 'Total Students',
      activeThisWeek: '{{count}} active this week',
      lessonsCreated: 'Lessons Created',
      qualityContentLibrary: 'Quality content library',
      avgPerformance: 'Avg Performance',
      thisMonth: '{{trend}} this month',
      pendingReviews: 'Pending Reviews',
      requiresAttention: 'Requires your attention',
      studentPerformanceOverview: 'Student Performance Overview',
      realTimeInsights: 'Real-time insights into your students\' progress',
      topPerformers: 'Top Performers',
      studentsAbove85: 'Students above 85%',
      atRisk: 'At Risk',
      needIntervention: 'Need intervention',
      viewDetailedAnalytics: 'View Detailed Analytics',
      todaySchedule: 'Today\'s Schedule',
      noUpcomingClasses: 'No upcoming classes today',
      quickActions: 'Quick Actions',
      createNewLesson: 'Create New Lesson',
      reviewAssignments: 'Review Assignments',
      viewClassAnalytics: 'View Class Analytics',
      sendAnnouncement: 'Send Announcement',
    },
    teacherDashboard: {
      noClassesScheduled: 'No classes scheduled for today',
      recentActivity: 'Recent Activity',
      noRecentActivity: 'No recent activity',
      alertsAndNotifications: 'Alerts & Notifications',
      noNewAlerts: 'No new alerts',
      quickActions: 'Quick Actions',
      createNewLesson: 'Create New Lesson',
      createAssessment: 'Create Assessment',
      gradeEntry: 'Grade Entry',
      attendance: 'Attendance',
      pendingReviews: 'Pending Reviews',
      viewAll: 'View All ({{count}})',
      noPendingReviews: 'No pending reviews',
      currentStudents: 'Students enrolled: {{count}}',
    },
    freemiumDashboard: {
      error: 'Error',
      success: 'Success!',
      failedToLoadDashboard: 'Failed to load dashboard data',
      failedToStartTrial: 'Failed to start trial. Please try again.',
      failedToCreateSampleData: 'Failed to create sample data.',
      trialStarted: 'Trial Started!',
      trialStartedDescription: 'You now have access to premium features for 14 days.',
      sampleDataCreated: 'Sample Data Created!',
      sampleDataCreatedDescription: 'Explore the features with sample exams and questions.',
      examUploadedSuccessfully: 'Exam uploaded successfully!',
      premiumTrial: 'Premium Trial',
      plan: '{{tier}} Plan',
      parent: 'Parent',
      welcome: 'Welcome, {{name}}!',
      trialMessage: "You're on a premium trial! Explore all features.",
      discoverMessage: 'Discover AI-powered exam preparation and tutoring for your child',
      trialEnds: 'Trial ends: {{date}}',
      startFreeTrial: 'Start Free Trial',
      trySampleData: 'Try Sample Data',
      aiQuestions: 'AI Questions',
      examUploads: 'Exam Uploads',
      practiceSessions: 'Practice Sessions',
      unlimited: 'unlimited',
      thisMonth: 'This month',
      today: 'Today',
      upgradeForMore: 'Upgrade for More',
      uploadExam: 'Upload Exam',
      aiPoweredExamPrep: 'AI-Powered Exam Preparation',
      examPrepDescription: 'Upload past exams and get AI-generated practice questions',
      smartQuestionGeneration: 'Smart question generation',
      adaptiveDifficultyLevels: 'Adaptive difficulty levels',
      progressTrackingAnalytics: 'Progress tracking & analytics',
      uploadLimitReached: 'Upload Limit Reached',
      uploadYourFirstExam: 'Upload Your First Exam',
      aiTutoringAssistant: 'AI Tutoring Assistant',
      aiTutoringDescription: 'Get instant help and explanations for any subject',
      aiTutorAvailability: '24/7 AI tutor availability',
      stepByStepExplanations: 'Step-by-step explanations',
      multiLanguageSupport: 'Multi-language support',
      startAiTutoringSession: 'Start AI Tutoring Session',
      unlockFullPotential: 'Unlock the full potential of AppAcademia',
      getUnlimitedAccess: 'Get unlimited AI questions, exam uploads, and advanced analytics',
      freeTrial: 'Free Trial',
      upgradeNow: 'Upgrade Now',
      quickStartGuide: 'Quick Start Guide',
      quickStartDescription: 'Get started with AppAcademia in just a few steps',
      step1Title: '1. Upload Exam',
      step1Description: 'Upload a past exam or practice test',
      step2Title: '2. Generate Questions',
      step2Description: 'Let AI create similar practice questions',
      step3Title: '3. Track Progress',
      step3Description: 'Monitor learning and improvement',
    },
    ai: {
      tutorName: 'AI Tutor',
      copilot: 'Teaching Copilot',
      askQuestion: 'Ask a question...',
      thinking: 'Thinking...',
      languageNote: 'I can help you in English',
      // AI Tutor Page
      tutorPageTitle: 'AI Tutor',
      tutorPageDescription: 'Get personalized help and explanations from your 24/7 AI tutoring assistant',
      // AI Tutor Widget
      chatWithTutor: 'Chat with AI Tutor',
      typeMessage: 'Type your message...',
      send: 'Send',
      minimize: 'Minimize',
      maximize: 'Maximize',
      close: 'Close',
      history: 'History',
      newChat: 'New Chat',
      chatHistory: 'Chat History',
      backToChat: 'Back to Chat',
      noSessions: 'No previous sessions',
      startChatting: 'Start chatting to create a session',
      errorLoadingHistory: 'Error loading chat history',
      errorSendingMessage: 'Failed to send message. Please try again.',
      selectSession: 'Select a session to continue',
      welcomeMessage: 'Hello! I\'m your AI tutor. How can I help you today?',
      sessionStarted: 'Session started',
      messagesCount: '{{count}} messages',
      you: 'You',
      tutor: 'AI Tutor',
      processing: 'Processing...',
      tryAgain: 'Try again',
    },
    examPrep: {
      title: 'Exam Preparation',
      subtitle: 'Upload exams, practice with AI-generated questions, and track your progress',
      examLibrary: 'Exam Library',
      myProgress: 'My Progress',
      availableExams: 'Available Exams',
      browseExams: 'Browse and practice with uploaded exams',
      uploadExam: 'Upload Exam',
      uploadYourFirstExam: 'Upload Your First Exam',
      yourProgress: 'Your Progress',
      trackPerformance: 'Track your performance across different subjects and topics',
      uploadAndPractice: 'Upload and practice with your past exams',
      searchExams: 'Search exams...',
      allSubjects: 'All Subjects',
      allTypes: 'All Types',
      noExamsUploaded: 'No exams uploaded yet',
      noExamsMatchFilter: 'No exams match your filters',
      uploadFirstExamMessage: 'Upload your first past exam to start practicing with AI-generated questions.',
      adjustFilterMessage: 'Try adjusting your search or filter criteria.',
      grade: 'Grade',
      startPractice: 'Start Practice',
      viewAnalytics: 'View Analytics',
      delete: 'Delete',
      ready: 'Ready',
      processing: 'Processing...',
      failed: 'Failed',
      pending: 'Pending',
      readiness: 'Readiness',
      questions: 'Questions',
      sessions: 'Sessions',
      practice: 'Practice',
      processingExamContent: 'Processing exam content...',
      processingFailed: 'Processing failed. Try re-uploading.',
      examDeleted: 'Exam Deleted',
      examDeletedSuccess: 'The exam has been successfully deleted.',
      deleteConfirm: 'Are you sure you want to delete this exam? This action cannot be undone.',
      loadingExams: 'Loading exams...',
      failedToLoad: 'Failed to load exams. Please try again.',
      failedToDelete: 'Failed to delete exam. Please try again.',
      subjects: {
        mathematics: 'Mathematics',
        science: 'Science',
        english: 'English',
        history: 'History',
        physics: 'Physics',
        chemistry: 'Chemistry',
        biology: 'Biology',
      },
      examTypes: {
        midterm: 'Midterm',
        final: 'Final',
        quiz: 'Quiz',
        practice: 'Practice',
        mock: 'Mock Exam',
      },
      aiCoach: {
        title: 'AI Study Coach',
        tab: 'Coach',
        description: 'Get personalized study help, explanations, and guidance',
        welcome: "I'm your AI study coach! Ask me anything about the topic you're studying.",
        placeholder: 'Ask a question...',
        unavailable: 'Coach is currently unavailable. Please try again later.',
        offline: 'Offline',
      },
      spacedRepetition: {
        title: 'Spaced Repetition Review',
        subtitle: 'Review flashcards due today',
        allDone: 'All caught up!',
        noCards: "You've reviewed all due cards. Check back later for more.",
        tapToReveal: 'Tap to reveal answer',
        tapToHide: 'Tap to hide answer',
        nextReview: 'Next review',
        reviews: 'Reviews',
        again: 'Again',
        hard: 'Hard',
        good: 'Good',
        easy: 'Easy',
        error: 'Failed to load review cards.',
      },
      paperPicker: {
        label: 'Paper',
        noPaper: 'No parsed paper yet',
        noPaperHint: 'Upload a past paper: its questions become your practice set, review cards and predictions.',
      },
      microSession: {
        noQuestions: 'Nothing to practise yet',
        noQuestionsHint: 'Once a past paper has been parsed, its questions appear here.',
        typeAnswer: 'Type your answer',
        check: 'Check answer',
        correctAnswer: 'Expected answer',
        noKey: 'not in the paper — compare with your teacher',
        title: 'Quick Study Session',
        subtitle: 'Quick focused practice from your weakest topics',
        description: 'focused questions from your weakest topics',
        start: 'Start Quick Quiz',
        complete: 'Session Complete!',
        correct: 'correct',
        tryAgain: 'Try Another Session',
        finish: 'Finish',
      },
      gamification: {
        title: 'Your Progress',
        level: 'Level',
        toNextLevel: 'to next level',
        dayStreak: 'day streak',
        longest: 'Longest',
        days: 'days',
        dailyCheckIn: 'Daily Check-in',
        checkedIn: 'Daily Check-in! 🎉',
        alreadyCheckedIn: 'Checked in today!',
        xpEarned: 'XP earned!',
        badges: 'Badges',
      },
      predictions: {
        predictedScore: 'Predicted Score',
        confidenceRange: 'Confidence',
        cohortComparison: 'Cohort Comparison',
        topPercentile: 'Top',
        yourScore: 'You',
        average: 'Avg',
        learningVelocity: 'Learning Velocity',
        velocityDesc: 'Score improvement rate per topic over time',
        forgettingCurves: 'Memory Retention',
        forgettingDesc: 'How quickly knowledge fades without review',
        reviewBy: 'review by',
      },
      wellness: {
        checkIn: 'Wellness Check-in',
        howAreYou: 'How are you feeling right now?',
        beforeStudy: 'Before Study',
        afterStudy: 'After Study',
        mood: 'Mood',
        energy: 'Energy Level',
        stressLevel: 'Stress Level',
        stressLow: 'Low',
        stressMedium: 'Medium',
        stressHigh: 'High',
        logCheckIn: 'Log Check-in',
        logged: 'Wellness Logged ✨',
        loggedDesc: 'Your check-in has been recorded.',
        weeklySummary: 'Weekly Summary',
        avgMood: 'Avg Mood',
        avgEnergy: 'Avg Energy',
        tips: 'Wellness Tips',
      },
      confidence: {
        title: 'Confidence Tracker',
        description: 'Rate your confidence per topic and compare with actual performance',
        selfRating: 'Self',
        actual: 'Actual Performance',
        actualBar: 'Actual Score',
        selfMarker: 'Self-Rating',
      },
    },
    teacherScreens: {
      attendance: {
        class: 'Class',
        selectClass: 'Select a class',
        date: 'Date',
        roll: 'Roll Call',
        stats: 'Statistics',
        allPresent: 'All present',
        allAbsent: 'All absent',
        students: 'students',
        present: 'present',
        absent: 'absent',
        late: 'late',
        saveRoll: 'Save roll call',
        saving: 'Saving...',
        unsavedChanges: 'You have unsaved changes. Continue without saving?',
        saveSuccess: '✓ Roll saved for {{class}} — {{date}}',
        saveError: '❌ Save error. Retry',
        retry: 'Retry',
        noStudents: 'No students enrolled in this class',
        addStudentsHint: 'Add students from class management',
        attendanceStats: 'Attendance Statistics',
        noStatsData: 'No attendance data available',
        statusPresent: 'Present',
        statusAbsent: 'Absent',
        statusLate: 'Late',
        statusExcused: 'Excused',
        absenceReason: 'Absence reason...',
        lateReason: 'Late reason...',
        excuseReason: 'Excuse reason...',
      },
      grades: {
        title: 'Grade Entry',
        subtitle: 'Enter grades for your classes',
        classSubject: 'Class & Subject',
        select: 'Select...',
        trimester: 'Trimester',
        sequence: 'Sequence',
        trimesterAverage: 'Trimester average',
        sequence1: 'Sequence 1',
        sequence2: 'Sequence 2',
        student: 'Student',
        grade: 'Grade',
        appreciation: 'Appreciation',
        filled: 'Filled',
        average: 'Average',
        min: 'Min',
        max: 'Max',
        save: 'Save grades',
        saving: 'Saving...',
        excellent: 'Excellent',
        veryGood: 'Very good',
        good: 'Good',
        fairlyGood: 'Fairly good',
        passable: 'Passable',
        insufficient: 'Insufficient',
        saveSuccess: 'Grades saved successfully',
        saveError: 'Error saving. Please retry.',
      },
      gradeHistory: {
        title: 'Grade History',
        subtitle: 'Search and view entered grades',
        searchStudent: 'Search a student',
        studentName: 'Student name...',
        class: 'Class',
        all: 'All',
        subject: 'Subject',
        trimester: 'Trimester',
        notes: 'Grades',
        average: 'Average',
        min: 'Min',
        max: 'Max',
        noGrades: 'No grades found',
        enterGradesHint: 'Enter grades via the "Grade Entry" tab',
        seq: 'Seq.',
        avg: 'Avg.',
        date: 'Date',
        student: 'Student',
        classroom: 'Class',
        noteCol: 'Grade',
        appreciationCol: 'Appreciation',
        excellent: 'Excellent',
        veryGood: 'Very Good',
        good: 'Good',
        fairlyGood: 'Fairly Good',
        passable: 'Passable',
        insufficient: 'Insufficient',
      },
      calendar: {
        title: 'My Timetable',
        subtitle: 'Current week',
        grid: 'Grid',
        list: 'List',
        perWeek: 'per week',
        classes: 'classes',
        subjects: 'subjects',
        noSlots: 'No slots in your timetable',
        configuredByAdmin: 'Slots will appear once configured by administration',
        today: 'Today',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
      },
      payslips: {
        title: 'My Payslips',
        subtitle: 'View your pay slips',
        totalPaid: 'Total paid',
        slips: 'Slips',
        noSlips: 'No payslips available',
        slipsWillAppear: 'Payslips will appear once generated by administration',
        draft: 'Draft',
        pending: 'Pending',
        approved: 'Approved',
        paid: 'Paid',
        earnings: 'Earnings',
        deductions: 'Deductions',
        net: 'Net',
      },
    },
    attendance: {
      title: 'Attendance Scanner',
      subtitle: 'Scan student QR codes or search to record attendance',
      gateEntry: 'Gate Entry',
      gateExit: 'Gate Exit',
      busBoarding: 'Bus Boarding',
      busAlighting: 'Bus Alighting',
      scanPlaceholder: 'Scan QR code or enter student ID...',
      scan: 'Scan',
      scanMode: 'Scan',
      searchMode: 'Search',
      searchStudentPlaceholder: 'Search student by name...',
      noResults: 'No students found',
      scanSuccess: 'Scan Successful',
      scanFailed: 'Scan Failed',
      scanFailedMsg: 'Scan failed',
      scanError: 'Scan Error',
      notificationsSent: 'Notifications Sent',
      notifyFailed: 'Failed to send notifications',
      totalStudents: 'Total Students',
      present: 'Present',
      missing: 'Missing',
      late: 'Late',
      scanStudent: 'Scan Student',
      missingStudents: 'Missing Students',
      notifyParents: 'Notify Parents',
      allPresent: 'All students are present!',
      recentScans: 'Recent Scans',
      studentId: 'ID',
      grade: 'Grade',
      gradeShort: 'Gr.',
      absent: 'Absent',
      excused: 'Excused',
      absenceReason: 'Reason for absence...',
      latenessReason: 'Reason for lateness...',
      excuseReason: 'Reason for excuse...',
      class: 'Class',
      selectClass: 'Select a class',
      students: 'students',
      date: 'Date',
      rollCall: 'Roll Call',
      statistics: 'Statistics',
      noStudents: 'No students enrolled in this class',
      addStudentsHint: 'Add students from class management',
      allAbsent: 'All absent',
      lateCount: 'late',
      unsavedChangesTitle: 'Unsaved Changes',
      unsavedChanges: 'You have unsaved changes. Continue without saving?',
      savedSuccess: '✓ Attendance saved for {{className}} — {{date}}',
      saveError: 'Save failed. Please retry',
      saveRollCall: 'Save roll call',
      attendanceStats: 'Attendance Statistics',
      noData: 'No attendance data available',
      loadStudentsFailed: 'Failed to load students for this class',
      history: 'Attendance History',
      startDate: 'Start Date',
      endDate: 'End Date',
      loadHistory: 'Load',
      exportCSV: 'Export CSV',
      summaryByEmployee: 'Summary by Employee',
      detailedRecords: 'Detailed Records',
      daysPresent: 'Days Present',
      daysLate: 'Late Days',
      totalHours: 'Total Hours',
      name: 'Name',
      role: 'Role',
      checkInTime: 'Check In',
      checkOutTime: 'Check Out',
      hours: 'Hours',
      status: 'Status',
      noHistory: 'No attendance records found for this period',
      historyLoadError: 'Failed to load history',
      exportFailed: 'Export failed',
      manualEntry: 'Roll Call',
      scanner: 'Scanner',
      saving: 'Saving...',
      loadingStudents: 'Loading students...',
      selectClassFirst: 'Select a classroom and date to begin roll call',
      markAllPresent: 'All Present',
      notes: 'Notes',
    },
    suivi: {
      dashboard: 'Dashboard',
      observations: 'Observations',
      atRisk: 'At-Risk',
      timeline: 'Timeline',
      totalObservations: 'Total Observations',
      behavioralIncidents: 'Behavioral Incidents',
      flaggedStudents: 'Flagged Students',
      pendingFollowups: 'Pending Follow-ups',
      severityBreakdown: 'Severity Breakdown',
      resolutionStatus: 'Resolution Status',
      recentCritical: 'Recent Critical/Major',
      noCritical: 'No critical incidents',
      pendingFollowupsTitle: 'Overdue Follow-ups',
      dashboardError: 'Unable to load dashboard',
      unknown: 'Unknown',
      all: 'All',
      exportPDF: 'Export PDF',
      newObservation: 'New Observation',
      searchPlaceholder: 'Search by student name or observation...',
      class: 'Class',
      selectClass: 'Select a class',
      student: 'Student',
      selectStudent: 'Select a student',
      type: 'Type',
      severity: 'Severity',
      date: 'Date',
      interventionType: 'Intervention Type',
      followUpDate: 'Follow-up Date',
      observation: 'Observation',
      observationPlaceholder: 'Describe the pedagogical observation...',
      strengths: 'Strengths',
      areasForImprovement: 'Areas for Improvement',
      actionPlan: 'Action Plan',
      competencyDomain: 'Competency Domain',
      selectDomain: 'Select a domain',
      competencySnapshot: 'Competency Levels',
      parentNotified: 'Parent Notified',
      private: 'Private (staff only)',
      parentsNotified: 'Parents notified',
      noObservations: 'No pedagogical observations',
      clickNewToStart: 'Click "New Observation" to start tracking your students',
      intervention: 'Intervention',
      markResolved: 'Mark as Resolved',
      noAtRisk: 'No at-risk students identified',
      totalIncidents: 'total incidents',
      viewTimeline: 'View Timeline',
      behavioral60d: 'Behavioral (60d)',
      unresolvedCritical: 'Unresolved Critical',
      overdueFollowups: 'Overdue Follow-ups',
      latest: 'Latest',
      noTimelineData: 'No timeline data for this student',
      academic: 'Academic',
      behavioral: 'Behavioral',
      social: 'Social',
      competency: 'Competency',
      health: 'Health',
      severityInfo: 'Info',
      severityWarning: 'Warning',
      severityMajor: 'Major',
      severityCritical: 'Critical',
      interventionNone: 'None',
      interventionParentMeeting: 'Parent Meeting',
      interventionCounseling: 'Counseling',
      interventionDetention: 'Detention',
      interventionReward: 'Reward',
      interventionTutoring: 'Tutoring',
      interventionReferral: 'Referral',
      aiAnalysis: 'AI Analysis',
      aiSummary: 'AI Analysis Summary',
      observationsAnalyzed: 'Observations analyzed',
      riskAssessment: 'Risk Assessment',
      risk_low: 'LOW',
      risk_medium: 'MEDIUM',
      risk_high: 'HIGH',
      risk_critical: 'CRITICAL',
      patterns: 'Behavioral Patterns',
      predictions: 'Predictions',
      suggestions: 'Intervention Suggestions',
      analyzing: 'Analyzing...',
      runAnalysis: 'Run AI Analysis',
      aiEmptyTitle: 'AI-Powered Student Analysis',
      aiEmptyDesc: 'Select a class and student to generate an AI-powered behavioral analysis with predictions and intervention suggestions.',
      chooseClass: '-- Choose a class --',
      chooseStudent: '-- Choose a student --',
      searchStudent: 'Search Student',
      searchByNameOrId: 'Search by name or student ID...',
      noStudentsFound: 'No students found',
      immediateActions: 'Immediate Actions',
      conflictAnalysis: 'Cross-Student Conflict Analysis',
      involvedPeers: 'Involved Peers',
      incidents: 'incidents',
      sameDayEvents: 'same-day events',
      nameCrossRef: 'name cross-referenced',
      parentGuidance: 'Guidance for Parents',
      teacherGuidance: 'Guidance for Teachers',
      // Enhanced AI analysis keys
      aiPowered: '🤖 AI-Powered',
      statisticalAnalysis: '📊 Statistical Analysis',
      gradeEntries: 'grades',
      attendanceDays: 'attendance days',
      homeworkEntries: 'homework',
      peerConflicts: 'peer conflicts',
      riskFactors: 'Risk Factors',
      factor_behavioral_observations: 'Behavioral observations',
      factor_severity_escalation: 'Severity escalation',
      factor_unresolved_issues: 'Unresolved issues',
      factor_academic_performance: 'Academic performance',
      factor_academic_decline: 'Academic decline',
      factor_attendance: 'Attendance',
      factor_homework_completion: 'Homework completion',
      observationTrend: 'Observation Trend',
      gradeTrajectory: 'Grade Trajectory',
      attendanceRate: 'Attendance Rate',
      homeworkCompletion: 'Homework Completion',
      trend_increasing: 'Increasing',
      trend_decreasing: 'Decreasing',
      trend_stable: 'Stable',
      trend_new_activity: 'New Activity',
      trend_no_data: 'No Data',
      trajectory_improving: 'Improving',
      trajectory_declining: 'Declining',
      trajectory_stable: 'Stable',
      correlations: 'Detected Correlations',
      temporalPatterns: 'Temporal Patterns',
      strength_strong: 'Strong',
      strength_moderate: 'Moderate',
      strength_weak: 'Weak',
      peakDay: 'Peak Day',
      ofIncidents: 'of incidents',
      incidentFrequency: 'Incident Frequency',
      avgInterval: 'Avg interval',
      days: 'days',
      accelerating: 'Accelerating',
      crossRef_bidirectional: 'bidirectional cross-reference',
      crossRef_student_in_peer: 'student mentioned in peer records',
      crossRef_peer_in_student: 'peer mentioned in student records',
      crossRef_date_overlap: 'date overlap',
    },
    pricing: {
      tag: 'Popular',
      individual: 'Individual',
      school: 'School',
      free: { name: 'Free', desc: 'Discover the platform' },
      studentPro: { desc: 'Full access for students' },
      teacherPro: { desc: 'Advanced tools for teachers' },
      family: { name: 'Family', desc: "Track your children's education" },
      starter: { desc: 'For small schools' },
      enterprise: { desc: 'For large institutions' },
      pro: { schoolDesc: 'Complete school management' },
      getStarted: 'Get Started',
      startTrial: 'Free Trial',
      startTrial30: '30-day Free Trial',
      contactSales: 'Contact Sales',
      currentPlan: 'Current Plan',
      schoolPays: 'Your school covers this',
      schoolPaysDesc: 'Your subscription is managed by your institution.',
      paymentMethods: 'Payment methods',
    },
    schoolModules: {
      title: 'School Management',
      subtitle: 'Manage your school: attendance, grades, fees, and more',
      seedDemo: 'Demo Data',
      seeding: 'Loading...',
      seedSuccess: 'Demo data created',
      seedSuccessDesc: '{{count}}/6 modules populated successfully',
      seedError: 'Unable to create demo data',
      noSchool: 'Please join a school to access this module.',
      error: 'Error',
      success: 'Success',
      fees: {
        title: 'Fee Collection',
        summary: 'Fee Summary',
        categories: 'Fee Categories',
        payments: 'Payments',
        totalExpected: 'Total Expected',
        totalCollected: 'Total Collected',
        outstanding: 'Outstanding',
        collectionRate: 'Collection Rate',
        createCategory: 'Create Category',
        recordPayment: 'Record Payment',
        studentFees: 'Student Fees',
        paid: 'Paid',
        partial: 'Partial',
        pending: 'Pending',
        overdue: 'Overdue',
        unpaid: 'Unpaid',
        loadError: 'Failed to load fee data',
        categoryCreated: 'Fee category created',
        paymentRecorded: 'Payment recorded',
        error: 'Error',
        success: 'Success',
        saved: 'Saved',
        tabOverview: 'Overview',
        tabStructures: 'Fee Structures',
        tabStudents: 'Student Fees',
        tabPayments: 'Payments',
        tabReminders: 'Reminders',
        addCategory: 'Add Category',
        createStructureBtn: 'Create Structure',
        assignFee: 'Assign Fee',
        applyDiscount: 'Apply Discount',
        active: 'Active',
        inactive: 'Inactive',
        allStatuses: 'All Statuses',
        allGrades: 'All',
        payMethod_mtn_momo: 'MTN MoMo',
        payMethod_orange_money: 'Orange Money',
        payMethod_wave: 'Wave',
        payMethod_express_union: 'Express Union',
        payMethod_emf_agent: 'EMF',
        payMethod_cheque: 'Cheque',
        payMethod_online: 'Online',
        payMethod_cash: 'Cash',
        payMethod_bank_transfer: 'Bank Transfer',
        payMethod_mobile_money: 'Mobile Money (MTN/Orange)',
        payMethod_card: 'Card',
        discType_scholarship: '🎓 Scholarship',
        discType_sibling: '👨‍👩‍👧‍👦 Sibling Discount',
        discType_staff_child: '👩‍🏫 Staff Child',
        discType_financial_aid: '🤝 Financial Aid',
        discType_custom: '✏️ Custom',
        noCategoriesTitle: 'No fee categories yet',
        noCategoriesDesc: 'Create your first fee category to start tracking tuition, registration fees, and other charges.',
        structuresLabel: 'Structures',
        studentsWithArrears: '{{count}} student(s) with outstanding arrears',
        noStructuresTitle: 'No fee structures yet',
        noStructuresDesc: 'Create a fee structure to define amounts for each category and grade level.',
        thCategory: 'Category',
        thGradeLevel: 'Grade Level',
        thAmount: 'Amount',
        thInstallments: 'Installments',
        thDueDate: 'Due Date',
        thLateFee: 'Late Fee %',
        thStatus: 'Status',
        searchStudent: 'Search student...',
        noStudentFeesTitle: 'No student fees',
        noStudentFeesEmpty: 'Assign fees to students using the "Assign Fee" button above.',
        noStudentFeesFiltered: 'No fees match your search criteria.',
        thStudent: 'Student',
        thTotal: 'Total',
        thPaid: 'Paid',
        thBalance: 'Balance',
        thAction: 'Action',
        payBtn: 'Pay',
        studentFeesSummary: '{{count}} student fee(s) • Total balance: {{balance}}',
        noPaymentsTitle: 'No payments recorded yet',
        noPaymentsDesc: 'Payments will appear here when you record them via the "Record Payment" button or the Students tab.',
        recordFirstPayment: 'Record First Payment',
        thDate: 'Date',
        thMethod: 'Method',
        thReference: 'Reference',
        paymentsSummary: '{{count}} payment(s) • Total: {{total}}',
        preDueReminders30d: 'Pre-due Reminders (30d)',
        overdueReminders30d: 'Overdue Reminders (30d)',
        totalSent30d: 'Total Sent (30d)',
        sendRemindersNow: 'Send Reminders Now',
        sendRemindersDesc: 'Manually trigger fee reminders for all parents with upcoming or overdue fees.',
        sendNow: 'Send Now',
        reminderSettings: 'Reminder Settings',
        preDueReminders: 'Pre-due Reminders',
        preDueDesc: 'Send reminders before the fee due date',
        sendReminder: 'Send reminder',
        beforeDueDate: 'before due date',
        overdueReminders: 'Overdue Reminders',
        overdueDesc: 'Send reminders after the fee due date has passed',
        sendEvery: 'Send every',
        whileOverdue: 'while overdue',
        maximum: 'Maximum',
        overdueRemindersLabel: 'overdue reminders',
        nDays: '{{n}} days',
        oneReminder: '1 reminder',
        nReminders: '{{n}} reminders',
        reminderTip: 'Reminders are automatically sent daily. You can also trigger them manually using the button above. Duplicate reminders are prevented within the configured interval.',
        structureCreated: 'Fee structure created',
        feeAssigned: 'Fee assigned to student',
        discountApplied: 'Discount applied',
        createCategoryError: 'Failed to create category',
        createStructureError: 'Failed to create structure',
        assignFeeError: 'Failed to assign fee',
        recordPaymentError: 'Failed to record payment',
        applyDiscountError: 'Failed to apply discount',
        reminderSettingsUpdated: 'Reminder settings updated',
        updateSettingsError: 'Failed to update settings',
        remindersSent: 'Reminders Sent',
        remindersSentDesc: '{{preDue}} pre-due + {{overdue}} overdue reminders sent',
        errorsLabel: 'errors',
        sendRemindersError: 'Failed to send reminders',
        declarationsTitle: "Payments declared by parents, to check ({{count}})",
        confirmDeclaration: "Confirm and issue the receipt",
        rejectDeclaration: "Not found",
        rejectReason: "Why is this payment not confirmed? (the parent will read it)",
        declarationConfirmed: "Payment confirmed",
        declarationRejectedToast: "The parent was told",
        ref: "ref.",
        familyReminded: "Reminder sent",
        familyRemindedDesc: "{{count}} parent(s) of {{name}} reminded",
        alreadyReminded: "This family was already reminded today",
        cannotRemind: "Nothing to remind: no balance or no parent linked to this pupil",
        addFeeCategoryTitle: 'Add Fee Category',
        categoryName: 'Category Name',
        categoryNamePlaceholder: 'e.g. Tuition, Registration, Transport',
        description: 'Description',
        briefDescription: 'Brief description',
        cancel: 'Cancel',
        create: 'Create',
        createFeeStructureTitle: 'Create Fee Structure',
        feeCategory: 'Fee Category',
        selectCategory: 'Select category...',
        gradeLevel: 'Grade Level',
        gradeLevelPlaceholder: 'e.g. 6ème, Terminale, All',
        amountXAF: 'Amount (XAF)',
        installments: 'Installments',
        dueDate: 'Due Date',
        lateFeePercent: 'Late Fee %',
        assignClassTitle: 'Assign a fee to a whole class',
        assignToStudent: 'One pupil',
        assignToClass: 'A whole class',
        classroom: 'Class',
        selectClass: 'Select a class…',
        classAssignHint: 'Every pupil of the class gets this fee; pupils who already have it are left as they are, and their discounts apply.',
        classAssigned: 'Fee assigned to {{count}} pupil(s)',
        classAssignedSkipped: 'Fee assigned to {{count}} pupil(s); {{skipped}} already had it',
        classEmpty: 'This class has no pupils yet',
        assignFeeTitle: 'Assign Fee to Student',
        feeStructure: 'Fee Structure',
        selectStructure: 'Select structure...',
        student: 'Student',
        selectStudent: 'Select student...',
        applyDiscountTitle: 'Apply Discount / Reduction',
        applyToStructure: 'Apply to Fee Structure (optional)',
        allFeesGlobal: 'All fees (global discount)',
        discountType: 'Discount Type',
        discountPercent: 'Discount %',
        discountPercentPlaceholder: 'e.g. 25',
        fixedAmountXAF: 'Fixed Amount (XAF)',
        reason: 'Reason',
        reasonPlaceholder: 'Reason for discount (optional)',
        recordPaymentTitle: 'Record Payment',
        studentFee: 'Student Fee',
        selectStudentFee: 'Select student fee...',
        studentFeeIdPlaceholder: 'Student Fee ID',
        paymentMethod: 'Payment Method',
        referenceNumber: 'Reference Number',
        referencePlaceholder: 'Transaction or receipt reference',
        exportStatement: 'Statement',
        printReceipt: 'Receipt',
        filterByClass: 'All Classes',
        classFilterInfo: 'Showing {{count}} students in {{className}}',
      },
      payroll: {
        title: 'Teacher Payroll',
        myPayslips: 'My Payslips',
        summary: 'Payroll Summary',
        salaries: 'Salaries',
        payslips: 'Pay Slips',
        config: 'Configuration',
        generate: 'Generate Pay Slips',
        approve: 'Approve',
        pay: 'Pay',
        draft: 'Draft',
        approved: 'Approved',
        grossSalary: 'Gross Salary',
        netSalary: 'Net Salary',
        baseSalary: 'Base Salary',
        transport: 'Transport Allowance',
        housing: 'Housing Allowance',
        tax: 'Tax',
        socialSecurity: 'Social Security',
        pension: 'Pension',
        noPayslips: 'No payslips available',
        noPayslipsDesc: 'Your payslips will appear here once generated by administration.',
        totalPaid: 'Total Paid',
        loadError: 'Failed to load payroll data',
      },
      sms: {
        title: 'SMS / WhatsApp',
        channelSms: 'SMS',
        channelWhatsapp: 'WhatsApp',
        channelEmail: 'Correo electrónico',
        compose: 'Compose',
        templates: 'Templates',
        history: 'History',
        send: 'Send',
        broadcast: 'Broadcast',
        totalSent: 'Total Sent',
        delivered: 'Delivered',
        failed: 'Failed',
        channel: 'Channel',
        recipients: 'Recipients',
        message: 'Message',
        noTemplates: 'No templates yet',
        loadError: 'Failed to load notification data',
        sent: 'Message sent',
        templateCreated: 'Template created!',
        composeMessage: 'Compose Message',
        commaSeparatedIds: '(comma-separated IDs)',
        typeMessageHere: 'Type your message here...',
        placeholderHint: 'Use {student_name}, {school_name}, {date} as placeholders',
        sending: 'Sending...',
        newTemplate: 'New Template',
        sendMessage: 'Send Message',
        searchTemplates: 'Search templates...',
        createFirstTemplate: 'Create your first message template',
        createTemplate: 'Create Template',
        use: 'Use',
        edit: 'Edit',
        searchMessages: 'Search messages...',
        noMessagesSent: 'No messages sent yet',
        historyAppearHere: 'Your notification history will appear here',
        date: 'Date',
        recipient: 'Recipient',
        status: 'Status',
        editTemplate: 'Edit Template',
        templateName: 'Template Name',
        templateNamePlaceholder: 'e.g. Attendance Alert',
        content: 'Content',
        contentPlaceholder: 'Dear {student_name}, your attendance on {date}...',
        trigger: 'Trigger',
        cancel: 'Cancel',
        saving: 'Saving...',
        saveTemplate: 'Save Template',
        broadcastMessage: 'Broadcast Message',
        broadcastPlaceholder: 'Enter broadcast message...',
        targetAudience: 'Target Audience',
        sendBroadcast: 'Send Broadcast',
        sentSuccess: 'Message sent successfully!',
        sendError: 'Failed to send message',
        templateUpdated: 'Template updated!',
        templateSaveError: 'Failed to save template',
        broadcastSuccess: 'Broadcast sent successfully!',
        broadcastError: 'Failed to send broadcast',
        templateLoaded: 'Template "{{name}}" loaded',
        templatesCount: 'Templates',
        success: 'Success',
        error: 'Error',
        close: 'Close',
        recipientsPlaceholder: 'student-001, student-002, parent-003...',
        status_queued: 'Queued',
        status_sent: 'Sent',
        status_delivered: 'Delivered',
        status_failed: 'Failed',
        trigger_manual: 'Manual',
        trigger_attendance: 'Attendance',
        trigger_grade_published: 'Grade Published',
        trigger_fee_reminder: 'Fee Reminder',
        trigger_event: 'Event',
        role_students: 'Students',
        role_teachers: 'Teachers',
        role_parents: 'Parents',
        searchRecipient: 'Search by name, email, or phone...',
      },
      inventory: {
        assets: 'Assets',
        categories: 'Categories',
        maintenance: 'Maintenance',
        totalAssets: 'Total Assets',
        available: 'Available',
        assigned: 'Assigned',
        totalValue: 'Total Value',
        createAsset: 'Create Asset',
        assign: 'Assign',
        return: 'Return',
        loadError: 'Failed to load inventory',
        assetCreated: 'Asset created',
        assetAssigned: 'Asset assigned',
        assetReturned: 'Asset returned',
        conditionEXCELLENT: 'Excellent',
        conditionGOOD: 'Good',
        conditionFAIR: 'Fair',
        conditionPOOR: 'Poor',
        conditionDAMAGED: 'Damaged',
        statusAVAILABLE: 'Available',
        statusASSIGNED: 'Assigned',
        statusMAINTENANCE: 'Maintenance',
        statusRETIRED: 'Retired',
        maintenanceDue: 'Maintenance Due',
        addCategory: 'Add Category',
        addAsset: 'Add Asset',
        logMaintenance: 'Log Maintenance',
        searchPlaceholder: 'Search assets by name, code or location...',
        allCategories: 'All Categories',
        allStatuses: 'All Statuses',
        categoryFilter: 'Category',
        statusFilter: 'Status',
        noAssetsFound: 'No assets found',
        noAssetsHint: 'Add your first asset or adjust filters',
        noCategoriesYet: 'No categories yet',
        noCategoriesHint: 'Create a category to organize your assets',
        noMaintenanceRecords: 'No maintenance records',
        noMaintenanceHint: 'Maintenance logs will appear here',
        assignedTo: 'Assigned',
        maintain: 'Maintain',
        uncategorized: 'Uncategorized',
        unknownAsset: 'Unknown Asset',
        completed: 'Completed',
        assetSingular: 'asset',
        assetPlural: 'assets',
        maintenanceType_preventive: 'Preventive',
        maintenanceType_corrective: 'Corrective',
        maintenanceType_inspection: 'Inspection',
        addNewAsset: 'Add New Asset',
        addNewAssetDesc: 'Register a new asset in the inventory system.',
        nameLabel: 'Name',
        assetCodeLabel: 'Asset Code',
        categoryLabel: 'Category',
        purchaseDateLabel: 'Purchase Date',
        purchasePriceLabel: 'Purchase Price (XAF)',
        locationLabel: 'Location',
        conditionLabel: 'Condition',
        statusLabel: 'Status',
        namePlaceholder: 'e.g. Dell Latitude 5520',
        autoGenerated: 'Auto-generated',
        selectCategory: 'Select a category',
        locationPlaceholder: 'e.g. Room 201, Lab A',
        cancel: 'Cancel',
        creating: 'Creating...',
        addCategoryTitle: 'Add Category',
        addCategoryDesc: 'Create a new category to organize assets.',
        categoryNameLabel: 'Category Name',
        descriptionLabel: 'Description',
        categoryNamePlaceholder: 'e.g. Computers, Furniture',
        categoryDescPlaceholder: 'Brief description of this category',
        createCategory: 'Create Category',
        assignAssetTitle: 'Assign Asset',
        assignAssetDescPre: 'Assign',
        assignAssetDescPost: 'to a user or department.',
        assignToLabel: 'Assign To',
        typeLabel: 'Type',
        notesLabel: 'Notes',
        assignToPlaceholder: 'Search user or enter name...',
        assignNotesPH: 'Assignment notes...',
        teacher: 'Teacher',
        classroom: 'Classroom',
        department: 'Department',
        assigning: 'Assigning...',
        assignAsset: 'Assign Asset',
        returnAssetTitle: 'Return Asset',
        returnAssetDescPre: 'Return',
        returnAssetDescPost: 'to inventory.',
        conditionOnReturn: 'Condition on Return',
        returnNotesPH: 'Return notes...',
        returning: 'Returning...',
        returnAsset: 'Return Asset',
        logMaintenanceTitle: 'Log Maintenance',
        logMaintenanceDescPre: 'Record maintenance for',
        maintenanceTypeLabel: 'Maintenance Type',
        preventive: 'Preventive',
        corrective: 'Corrective',
        inspection: 'Inspection',
        costLabel: 'Cost (XAF)',
        scheduledDateLabel: 'Scheduled Date',
        performedByLabel: 'Performed By',
        maintenanceDescPlaceholder: 'Describe the maintenance work...',
        technicianPlaceholder: 'Technician name',
        saving: 'Saving...',
        error: 'Error',
        success: 'Success',
        loadInventoryError: 'Failed to load inventory',
        loadMaintenanceError: 'Failed to load maintenance records',
        assetCreatedSuccess: 'Asset created successfully',
        assetCreateError: 'Failed to create asset',
        categoryCreatedSuccess: 'Category created successfully',
        categoryCreateError: 'Failed to create category',
        assetAssignedSuccess: 'Asset assigned successfully',
        assetAssignError: 'Failed to assign asset',
        assetReturnedSuccess: 'Asset returned successfully',
        assetReturnError: 'Failed to return asset',
        maintenanceLoggedSuccess: 'Maintenance logged successfully',
        maintenanceLogError: 'Failed to log maintenance',
      },
      transport: {
        title: 'Transport',
        routes: 'Routes',
        vehicles: 'Vehicles',
        students: 'Students',
        totalRoutes: 'Total Routes',
        totalVehicles: 'Vehicles',
        enrolledStudents: 'Enrolled Students',
        totalStops: 'Stops',
        createRoute: 'Add Route',
        createVehicle: 'Add Vehicle',
        enrollStudent: 'Enroll Student',
        monthlyFee: 'Monthly Fee',
        distance: 'Distance',
        estimatedTime: 'Estimated Time',
        noRoutes: 'No routes yet',
        noVehicles: 'No vehicles registered',
        loadError: 'Failed to load transport data',
        routeCreated: 'Route created',
        vehicleCreated: 'Vehicle created',
      },
      documents: {
        title: 'Documents',
        allDocuments: 'All Documents',
        categories: 'Categories',
        shared: 'Shared',
        upload: 'Upload',
        verify: 'Verify',
        share: 'Share',
        delete: 'Delete',
        verified: 'Verified',
        noDocuments: 'No documents found',
        uploadDocument: 'Upload Document',
        loadError: 'Failed to load documents',
        uploaded: 'Document uploaded',
        shared_success: 'Document shared',
        deleted: 'Document deleted',
        totalDocuments: 'Total Documents',
        pendingVerification: 'Pending Verification',
        storageUsed: 'Storage used:',
        categoriesCount: 'categories',
        searchPlaceholder: 'Search documents...',
        addCategory: 'Add Category',
        shareDocument: 'Share Document',
        tabDocuments: 'Documents',
        tabCategories: 'Categories',
        tabShared: 'Shared',
        fileBrowser: 'File Browser',
        uploadToStart: 'Upload documents to get started',
        studentLabel: 'Student:',
        verifiedBadge: 'Verified',
        pendingBadge: 'Pending',
        verifyAction: 'Verify',
        shareAction: 'Share',
        downloadAction: 'Download',
        deleteAction: 'Delete',
        noCategories: 'No categories yet',
        createCategoriesToOrganize: 'Create categories to organize documents',
        required: 'Required',
        documentSingular: 'document',
        documentsPlural: 'documents',
        sharedDocuments: 'Shared Documents',
        noSharedDocuments: 'No shared documents',
        shareWithOthers: 'Share documents with other users',
        sharedWith: 'Shared with:',
        expired: 'Expired',
        expires: 'Expires',
        documentFallback: 'Document',
        addCategoryTitle: 'Add Category',
        nameLabel: 'Name',
        namePlaceholder: 'e.g. Report Cards',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Brief description...',
        documentTypeLabel: 'Document Type',
        requiredCategory: 'Required document category',
        cancel: 'Cancel',
        createCategory: 'Create Category',
        uploadDocumentTitle: 'Upload Document',
        studentIdLabel: 'Student ID',
        studentIdPlaceholder: 'Enter student ID',
        categoryLabel: 'Category',
        selectCategory: 'Select category...',
        fileLabel: 'File',
        dropFileHere: 'Drop file here or click to browse',
        supportedFormats: 'PDF, images, Word, Excel supported',
        academicYearLabel: 'Academic Year',
        shareDocumentTitle: 'Share Document',
        documentLabel: 'Document',
        selectDocument: 'Select document...',
        shareWithLabel: 'Share With (User ID)',
        enterUserId: 'Enter user ID',
        accessLevelLabel: 'Access Level',
        expiryDateLabel: 'Expiry Date',
        optional: '(optional)',
        verifyDocumentTitle: 'Verify Document',
        confirmVerification: 'Confirm Verification',
        verifyDescription: 'This will mark the document as verified and record the verification timestamp.',
        notesLabel: 'Notes',
        notesPlaceholder: 'Verification notes...',
        verifyDocument: 'Verify Document',
      },
    },
    gradeEntry: {
      title: 'Grade Entry',
      subtitle: 'Fill in grades for your classes',
      classAndSubject: 'Class & Subject',
      class: 'Class',
      subject: 'Subject',
      current: 'current',
      select: 'Select...',
      trimester: 'Trimester',
      sequence: 'Sequence',
      trimesterAverage: 'Trimester average',
      sequence1: 'Sequence 1',
      sequence2: 'Sequence 2',
      gradesEntered: 'Grades entered',
      average: 'Average',
      maxGrade: 'Max grade',
      minGrade: 'Min grade',
      seqAbbrev: 'Seq.',
      saving: 'Saving...',
      saved: 'Saved!',
      save: 'Save',
      saveError: 'Error while saving. Please try again.',
      retry: 'Retry',
      student: 'Student',
      gradeOutOf20: 'Grade /20',
      appreciation: 'Appreciation',
      appreciationPlaceholder: 'Appreciation...',
      veryGood: 'Very good',
      good: 'Good',
      fairlyGood: 'Fairly good',
      passable: 'Passable',
      insufficient: 'Insufficient',
      veryInsufficient: 'Very insufficient',
      autoAppreciation: 'Auto-appreciation',
      emptyTitle: 'Select a class and a trimester',
      emptySubtitle: 'to start entering grades',
      loading: 'Loading grades...',
      students: 'students',
      coeff: 'Coeff.',
    },
    userManagement: {
      title: 'User Management',
      refresh: 'Refresh',
      invite: 'Invite',
      inviteUser: 'Invite a user',
      email: 'Email',
      emailPlaceholder: 'user@school.com',
      role: 'Role',
      select: 'Select...',
      sending: 'Sending…',
      sendInvitation: 'Send invitation',
      shareableLinkFor: 'Joins as {{role}} · code {{code}} · up to 50 people, until {{date}}',
      createLinkFor: 'Create a link for: {{role}}',
      parentCodeFor: 'Parent code · {{names}}',
      sharedLink: 'Shared link',
      usesCount: '{{used}}/{{max}} used',
      statusRevoked: 'Deactivated',
      noInvitationsDesc: 'Send invitations to staff and teachers to get started.',
      shareableLink: 'Shareable invitation link',
      shareableLinkDesc: 'Share this link to allow users to register directly.',
      copy: 'Copy',
      pendingTab: 'Pending',
      allTab: 'All',
      pendingInvitations: 'Pending invitations',
      noPendingInvitations: 'No pending invitations.',
      allInvitations: 'All invitations',
      noInvitationsFound: 'No invitations found.',
      statusPending: 'Pending',
      statusAccepted: 'Accepted',
      statusExpired: 'Expired',
      roleTeacher: 'Teacher',
      roleStudent: 'Student',
      roleParent: 'Parent',
      roleGuard: 'Security Guard',
      roleBusDriver: 'Bus Driver',
      roleCafeteriaStaff: 'Cafeteria Staff',
      roleEMFAgent: 'EMF Agent',
      roleAccountant: 'Accountant',
      roleSecretary: 'Secretary',
      roleSurveillantGeneral: 'General Supervisor',
      invalidEmail: 'Invalid email',
      invalidEmailDesc: 'Please enter a valid email address.',
      invitationSent: 'Invitation sent',
      invitationSentDesc: 'Invitation sent to {{email}}.',
      error: 'Error',
      sendError: 'Unable to send the invitation.',
      linkCopied: 'Link copied',
      linkCopiedDesc: 'The invitation link has been copied.',
      copyError: 'Unable to copy the link.',
    },
    teacherPayslips: {
      title: 'My payslips',
      subtitle: 'View your salary slips',
      error: 'Error',
      loadError: 'Unable to load your payslips',
      totalPaid: 'Total paid',
      payslips: 'Payslips',
      paid: 'Paid',
      noPayslips: 'No payslips available',
      noPayslipsDesc: 'Your payslips will appear here once generated by the administration.',
      statusDraft: 'Draft',
      statusPending: 'Pending',
      statusApproved: 'Approved',
      statusPaid: 'Paid',
      earnings: 'Earnings',
      baseSalary: 'Base salary',
      transport: 'Transport',
      housing: 'Housing',
      otherAllowances: 'Other',
      gross: 'Gross',
      deductions: 'Deductions',
      taxes: 'Taxes',
      socialSecurity: 'Social security',
      pension: 'Pension',
      otherDeductions: 'Other',
      netSalary: 'Net salary',
      paidOn: 'Paid on',
      months: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
      },
    },
    schoolCalendar: {
      mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat', sun: 'Sun',
      holiday: 'Holiday', exam: 'Exam', meeting: 'Meeting', classCouncil: 'Class council',
      schoolStart: 'School start', vacation: 'Vacation', pedagogicDay: 'Pedagogic day',
      ceremony: 'Ceremony', other: 'Other',
      upcomingEvents: 'Upcoming Events', noEvents: 'No events this month',
      loadError: 'Unable to load calendar events',
      addEvent: 'Add Event', eventTitle: 'Title', eventType: 'Type',
      startDate: 'Start Date', endDate: 'End Date', startTime: 'Start Time',
      description: 'Description', save: 'Save', cancel: 'Cancel',
      schoolEvents: 'School Events',
      studentLeaves: 'Student Leaves',
      staffLeaves: 'Staff Leaves',
      homeworkDue: 'Homework Due',
      filterEvents: 'Filter Events',
      allEvents: 'All Events',
      noEventsToday: 'No events today',
      more: 'more',
      until: 'Until',
    },
    schoolManagement: {
      title: 'School Management',
      subtitle: 'Manage your school: attendance, report cards, homework, timetable and more',
      loading: 'Loading...',
      demoData: 'Seed Full Year',
      demoDataDesc: 'Seeds a complete academic year with classes, teachers, students, grades, and more',
      demoDataCreated: 'Demo data created',
      modulesPopulated: 'modules populated successfully',
      error: 'Error',
      demoDataError: 'Unable to create demo data',
      quickStart: 'Quick start',
      completeSetup: 'Complete setup',
      classes: 'Classes',
      subjects: 'Subjects',
      checklist: {
        schoolCreated: 'School created',
        schoolYear: 'School year',
        classes: 'Classes',
        subjects: 'Subjects',
        teachersInvited: 'Teachers invited',
      },
      tabs: {
        tabSetup: 'Setup',
        tabAnalytics: 'Analytics',
        tabAttendance: 'Attendance',
        tabTimetable: 'Timetable',
        tabBulletins: 'Report cards',
        tabHomework: 'Homework',
        tabSuivi: 'Academic tracking',
        tabTeachingReports: 'Teaching reports',
        tabLeave: 'Leave / Absences',
        tabCalendar: 'Calendar',
        tabAppointments: 'Appointments',
        tabFees: 'School fees',
        tabPayroll: 'Teacher payroll',
        tabSms: 'SMS / WhatsApp',
        tabInventory: 'Inventory',
        tabTransport: 'Transport',
        tabDocuments: 'Documents',
      },
      tabGroupAcademic: 'Academic',
      tabGroupScheduling: 'Scheduling',
      tabGroupFinance: 'Finance',
      tabGroupOperations: 'Operations',
    },
    transport: {
      routes: 'Routes',
      vehicles: 'Vehicles',
      students: 'Students',
      overview: 'Overview',
      addRoute: 'Add Route',
      addVehicle: 'Add Vehicle',
      enrollStudent: 'Enroll Student',
      addStop: 'Add Stop',
      addRouteTitle: 'Add Route',
      addVehicleTitle: 'Add Vehicle',
      addStopTitle: 'Add Stop',
      enrollStudentTitle: 'Enroll Student in Transport',
      totalRoutes: 'Total Routes',
      totalVehicles: 'Active Vehicles',
      enrolledStudents: 'Students Enrolled',
      monthlyRevenue: 'Monthly Revenue',
      routeName: 'Route Name',
      startPoint: 'Start Point',
      endPoint: 'End Point',
      distance: 'Distance (km)',
      estimatedTime: 'Est. Time (min)',
      monthlyFee: 'Monthly Fee (XAF)',
      vehicleNumber: 'Vehicle Number',
      vehicleType: 'Vehicle Type',
      capacity: 'Capacity',
      driverName: 'Driver Name',
      driverPhone: 'Driver Phone',
      insuranceExpiry: 'Insurance Expiry',
      stopName: 'Stop Name',
      stopOrder: 'Stop Order',
      pickupTime: 'Pickup Time',
      dropoffTime: 'Dropoff Time',
      student: 'Student',
      selectStudent: 'Select a student',
      route: 'Route',
      selectRoute: 'Select a route',
      stop: 'Stop',
      selectStop: 'Select a stop',
      direction: 'Direction',
      morning: 'Morning',
      evening: 'Evening',
      both: 'Both',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      search: 'Search students, routes, stops...',
      noRoutes: 'No routes yet. Add your first route to get started.',
      noVehicles: 'No vehicles registered yet.',
      noStudents: 'No enrolled students found.',
      noStops: 'No stops added yet.',
      noSchool: 'Please join a school to manage transport.',
      loading: 'Loading...',
      active: 'Active',
      inactive: 'Inactive',
      seatsAvailable: 'seats',
      stops: 'stops',
      enrolled: 'Enrolled',
      fee: 'Fee',
      bus: 'Bus',
      minibus: 'Minibus',
      van: 'Van',
      latitude: 'Latitude',
      longitude: 'Longitude',
      departure: 'Departure',
      destination: 'Destination',
      fullName: 'Full name',
      numberOfSeats: 'Number of seats',
      insurance: 'Insurance',
      deleteRoute: 'Delete Route',
      deleteVehicle: 'Delete Vehicle',
      routeDetails: 'Route Details',
      vehicleDetails: 'Vehicle Details',
      errorLoadTransport: 'Failed to load transport data.',
      errorCreateRoute: 'Failed to create route.',
      errorCreateVehicle: 'Failed to create vehicle.',
      errorEnrollStudent: 'Failed to enroll student.',
      errorAddStop: 'Failed to add stop.',
      successRouteCreated: 'Route created successfully',
      successVehicleCreated: 'Vehicle created successfully',
      successStudentEnrolled: 'Student enrolled in transport',
      successStopAdded: 'Stop added successfully',
    },
    setupPresets: {
      title: 'Save time: choose your cycles',
      desc: 'The usual classes and subjects are created for you, with common coefficients. Untick what your school does not have; everything stays editable.',
      classes: 'Classes',
      subjects: 'Subjects',
      create: 'Create {{count}} classes',
      doneTitle: 'Classes created',
      done: '{{classes}} classes and {{subjects}} subjects created. You can rename, delete or duplicate them at any time.',
      failed: 'Could not create the classes. Try again.',
      duplicateOf: 'Duplicate {{name}} (same subjects and coefficients)',
      duplicate: 'Duplicate',
      orAddOne: 'Or add a class yourself:',
    },
    bulletin: {
      competencySystem: 'Competency-based assessment (Primary)',
      competencyLevels: 'Levels: D (Exceeded) • A (Acquired) • EA (In progress) • NA (Not acquired)',
      gradesSystem: 'Marks and coefficients (Secondary)',
      livretEmpty: 'Nothing to report this term: enter marks or assess competencies, then generate again.',
      teacherObservation: "Teacher's remark",
      absencesLine: 'Absences: {{count}} ({{justified}} excused)',
      latesLine: 'Late: {{count}}',
      competency: {
        title: 'Assess competencies',
        hint: 'Marks already entered count: each subject gives its domain a level. A competency assessed here takes precedence over the marks of its domain.',
        competency: 'Competency',
        domain: 'Domain',
        add: 'Add a competency',
        addShort: 'Add',
        none: 'No competency for {{grade}} yet. Add the first one:',
        namePlaceholder: 'e.g. Read and understand a short text',
        noPupils: 'This class has no pupils yet.',
        progress: '{{done}}/{{total}} pupil(s) assessed',
        loadFailed: 'Could not load the competencies.',
        saveFailed: 'The level was not saved. Please try again.',
        addFailed: 'The competency was not added (it may already exist).',
        level_D: 'Exceeded',
        level_A: 'Acquired',
        level_EA: 'In progress',
        level_NA: 'Not acquired',
      },
      remarksTitle: "Class council's remark",
      remarksHint: "The AI drafts a remark for each pupil from their marks, rank and absences. Read and correct them before saving. Pupils' names are never sent to the AI.",
      draftRemarks: 'Draft the remarks (AI)',
      drafting: 'Drafting...',
      saveRemarks: 'Save the remarks',
      saving: 'Saving...',
      remarksSaved: '{{count}} remark(s) saved',
      remarkPlaceholder: "Class council's remark for this pupil",
      aiDraft: 'AI draft — please review',
      plainDraft: 'Automatic draft — please review',
      draftFailed: 'Could not draft the remarks. Try again in a moment.',
      saveFailed: 'Saving failed. Try again.',
      replaceWritten: 'Some remarks are already written. Replace them with the drafts?',
      generateReports: 'Generate Reports',
      pdfTemplates: 'PDF Templates',
      class: 'Class',
      trimester: 'Trimester',
      selectClass: 'Select a class',
      selectTrimester: 'Select a trimester',
      livret: 'Livret',
      bulletin: 'Bulletin',
      generateBulletins: 'Generate Bulletins',
      generating: 'Generating...',
      gradesInfo: 'Grades /20 • Weighted averages • Rankings',
      noBulletins: 'No bulletins generated yet',
      generateFirst: 'Select a class and trimester, then generate bulletins',
      downloadPdf: 'Download PDF',
      viewDetails: 'View Details',
      average: 'Average',
      rank: 'Rank',
      status: 'Status',
      generated: 'Generated',
      pending: 'Pending',
      error: 'Error',
      student: 'Student',
      overallAverage: 'Overall Average',
      classAverage: 'Class Average',
      appreciation: 'Appreciation',
      conduct: 'Conduct',
    },
    communication: {
      title: 'Messages',
      searchConversations: 'Search conversations...',
      activeChats: 'Active Chats',
      messagesSent: 'Messages Sent',
      unread: 'Unread',
      newConversation: 'New Conversation',
      all: 'All',
      direct: 'Direct',
      groups: 'Groups',
      news: 'News',
      noConversations: 'No conversations yet',
      startConversation: 'Start a new conversation to begin messaging',
      online: 'Online',
      offline: 'Offline',
      startNewConversation: 'Start New Conversation',
      createDescription: 'Create a direct message or group conversation',
      conversationType: 'Conversation Type',
      directMessage: 'Direct Message',
      classGroup: 'Class Group',
      subjectGroup: 'Subject Group',
      groupName: 'Group Name',
      enterGroupName: 'Enter group name...',
      descriptionOptional: 'Description (optional)',
      whatsGroupAbout: "What's this group about?",
      selectUser: 'Select User',
      addParticipants: 'Add Participants',
      searchUsers: 'Search users...',
      noUsersFound: 'No users found',
      cancel: 'Cancel',
      createConversation: 'Create Conversation',
      filterAll: 'All',
      filterTeachers: 'Teachers',
      filterOffice: 'Office',
      yesterday: 'Yesterday',
      filterStudents: 'Students',
      filterParents: 'Parents',
      searchMessages: 'Search messages...',
      participants: 'participants',
      typeMessage: 'Type your message...',
      send: 'Send',
      failedToLoad: 'Failed to load messages',
      messageSendError: 'Failed to send message',
      restricted: 'Restricted',
      clearMessages: 'Clear messages',
      pinConversation: 'Pin conversation',
      unpinConversation: 'Unpin conversation',
      archiveConversation: 'Archive conversation',
      attachFile: 'Attach file',
      react: 'React',
      reply: 'Reply',
      edit: 'Edit',
      copy: 'Copy',
      forward: 'Forward',
      pin: 'Pin',
      delete: 'Delete',
      edited: 'edited',
      announcements: 'Announcements',
      noAnnouncements: 'No announcements',
      acknowledge: 'Acknowledge',
      acknowledged: 'Acknowledged',
      failedToLoadAnnouncements: 'Failed to load announcements',
      settings: 'Settings',
      notifications: 'Notifications',
      privacy: 'Privacy',
      quietHours: 'Quiet Hours',
      autoReply: 'Auto Reply',
      saveSettings: 'Save Settings',
      settingsSaved: 'Settings saved',
      settingsError: 'Failed to save settings',
      noMessagesYet: 'No messages yet',
      you: 'You',
      pinned: 'Pinned',
      replyingTo: 'Replying to',
      fileTooLarge: 'File too large',
      exceedsLimit: '{{name}} exceeds 10MB limit',
      conversationPinned: 'Conversation pinned',
      conversationUnpinned: 'Conversation unpinned',
      failedToPin: 'Failed to pin conversation',
      messagingRestricted: 'Messaging is restricted at this time',
      failedToDelete: 'Failed to delete message',
      failedToReact: 'Failed to add reaction',
      addEmoji: 'Add emoji',
      backToConversations: 'Back',
      startConversationPrompt: 'Start a conversation!',
    },
    students: {
      management: 'Students Management',
      subtitle: 'Track academic progress, manage enrollments, and support student success',
      import: 'Import',
      export: 'Export',
      addStudent: 'Add Student',
      totalStudents: 'Total Students',
      thisMonthGrowth: 'this month',
      avgGPA: 'Avg. GPA',
      avgGrade: 'Average',
      avgGradeHint: 'Latest report cards',
      avgGradeEmpty: 'No report card generated yet',
      attendanceHint: 'Across registers taken',
      attendanceEmpty: 'No register taken yet',
      gpaChange: '+0.08 from last',
      attendance: 'Attendance',
      thisMonth: 'This month',
      honorRoll: 'Honor Roll',
      percentOfStudents: '12.6% of students',
      atRisk: 'At Risk',
      needAttention: 'Need attention',
      searchPlaceholder: 'Search students by name or email...',
      allGrades: 'All Grades',
      allClasses: 'All Classes',
      gradeN: 'Grade {{n}}',
      allStatus: 'All Status',
      active: 'Active',
      inactive: 'Inactive',
      suspended: 'Suspended',
      graduated: 'Graduated',
      gpaLabel: 'Average /20',
      min: 'Min',
      max: 'Max',
      sortNameAZ: 'Name (A-Z)',
      sortNameZA: 'Name (Z-A)',
      sortGradeLowHigh: 'Grade (Low-High)',
      sortGradeHighLow: 'Grade (High-Low)',
      sortGPAHighLow: 'Average (high-low)',
      sortGPALowHigh: 'Average (low-high)',
      sortNewest: 'Newest First',
      loadingStudents: 'Loading students...',
      noStudentsFound: 'No students found',
      colStudent: 'Student',
      colGrade: 'Grade',
      colClass: 'Class',
      colGPA: 'GPA',
      colAttendance: 'Attendance',
      colProgress: 'Progress',
      colParents: 'Parents',
      colStatus: 'Status',
      colActions: 'Actions',
      connectedCount: '{{count}} connected',
      view: 'View',
      edit: 'Edit',
      previous: 'Previous',
      next: 'Next',
      showingPage: 'Showing page {{current}} of {{total}}',
      deactivateTitle: 'Deactivate Student',
      confirmDeactivate: 'Are you sure you want to deactivate this student?',
      success: 'Success',
      error: 'Error',
      deactivatedSuccess: 'Student deactivated successfully',
      failedToDeactivate: 'Failed to deactivate student',
      activatedSuccess: 'Student activated successfully',
      failedToActivate: 'Failed to activate student',
      importComplete: 'Import Complete',
      importResult: 'Successfully imported {{success}} students. {{failed}} failed.',
      failedToImport: 'Failed to import students',
      failedToFetch: 'Failed to fetch students',
      gender: 'Gender',
      selectGender: 'Select gender',
      male: 'Male',
      female: 'Female',
      importStudents: 'Import Students',
      importDesc: 'Upload a CSV file to bulk-import students. Use the template below to ensure correct formatting.',
      downloadTemplate: 'Download CSV Template',
      expectedColumns: 'Expected Columns',
      columnName: 'Column',
      required: 'Required',
      description: 'Description',
      col_fullName: 'Student full name',
      col_email: 'Student email address',
      col_grade: 'Grade level (1-12)',
      col_gender: 'M or F',
      col_parent: 'Parent/guardian email',
      col_dob: 'Date of birth (YYYY-MM-DD)',
      col_emergency: 'Emergency contact name and phone',
      col_medical: 'Medical conditions or notes',
      col_transport: 'Bus, Walk, Parent pickup, etc.',
      dragDrop: 'Drag & drop a CSV file here, or click to browse',
      csvOnly: 'Only .csv files are supported',
      assignToClass: 'Assign to Class',
      selectClassOptional: 'Select class (optional)',
      excelSupported: 'CSV and Excel (.xlsx) files are supported',
      ownListHint: 'Already have your class lists in Excel? Upload them as they are: French or English headers ("Noms et prénoms", "Nom" + "Prénom", "Sexe", "Né(e) le"...), titles above the table and one sheet per class all work. The template below is only needed if you start from nothing.',
    },
    studentForm: {
      editStudent: 'Edit Student',
      addNewStudent: 'Add New Student',
      fillRequired: 'Please fill in all required fields',
      updateSuccess: 'Student updated successfully',
      createSuccess: 'Student created successfully',
      saveFailed: 'Failed to save student',
      basicInfo: 'Basic Information',
      fullName: 'Full Name',
      email: 'Email',
      password: 'Password',
      gradeLevel: 'Grade Level',
      selectGrade: 'Select grade',
      gradeN: 'Grade {{n}}',
      parentInfo: 'Parent/Guardian Information',
      parentEmailPlaceholder: 'Parent email address',
      addParent: 'Add Parent',
      academicProfile: 'Academic Profile',
      learningStyle: 'Learning Style',
      selectLearningStyle: 'Select learning style',
      style_visual: 'Visual',
      style_auditory: 'Auditory',
      style_kinesthetic: 'Kinesthetic',
      style_reading_writing: 'Reading/Writing',
      style_mixed: 'Mixed',
      overallGPA: 'Overall GPA',
      preferredSubjects: 'Preferred Subjects',
      subject_mathematics: 'Mathematics',
      subject_science: 'Science',
      subject_english: 'English',
      subject_history: 'History',
      subject_geography: 'Geography',
      subject_physics: 'Physics',
      subject_chemistry: 'Chemistry',
      subject_biology: 'Biology',
      subject_computer_science: 'Computer Science',
      subject_art: 'Art',
      subject_music: 'Music',
      subject_physical_education: 'Physical Education',
      subject_foreign_language: 'Foreign Language',
      subject_social_studies: 'Social Studies',
      strengths: 'Strengths',
      strengthsPlaceholder: 'e.g., Strong problem-solving skills, excellent teamwork...',
      areasForImprovement: 'Areas for Improvement',
      areasPlaceholder: 'e.g., Time management, test anxiety...',
      additionalInfo: 'Additional Information',
      emergencyContact: 'Emergency Contact',
      emergencyPlaceholder: 'Name and phone number',
      transportMethod: 'Transportation Method',
      transportPlaceholder: 'e.g., Bus, Parent pickup, Walk',
      medicalNotes: 'Medical Notes',
      medicalPlaceholder: 'Any medical conditions or medications...',
      dietaryRestrictions: 'Dietary Restrictions',
      dietaryPlaceholder: 'e.g., Vegetarian, Gluten-free, Nut allergy...',
      extracurricular: 'Extracurricular Activities',
      addActivityPlaceholder: 'Add an activity...',
      updateStudent: 'Update Student',
      addStudent: 'Add Student',
      photo: 'Student Photo',
      photoHint: 'Click to upload (JPEG, PNG, WebP)',
      classroom: 'Class',
      selectClass: 'Select class',
    },
    studentDetails: {
      tabs: {
        overview: 'Overview',
        progress: 'Progress',
        sel: 'SEL',
        schedule: 'Schedule',
        parents: 'Parents',
        idCard: 'ID Card',
      },
      grade: 'Grade',
      matricule: 'Matricule',
      editStudent: 'Edit Student',
      parentGuardianInfo: 'Parent/Guardian Information',
      addParent: 'Add Parent',
      addNewParent: 'Add New Parent',
      noParentsConnected: 'No parents/guardians connected',
      parentCommunicationLog: 'Parent Communication Log',
      progressReportSent: 'Progress Report Sent',
      monthlyReportSent: 'Monthly progress report sent to all connected parents',
      parentTeacherConference: 'Parent-Teacher Conference',
      discussedProgress: 'Discussed academic progress and SEL goals',
      attendanceAlert: 'Attendance Alert',
      notifiedTardiness: 'Notified parents about recent tardiness pattern',
      stats: {
        gpa: 'GPA',
        attendance: 'Attendance',
        lessons: 'Lessons',
        selScore: 'SEL Score',
      },
      academicProfile: 'Academic Profile',
      learningStyle: 'Learning Style',
      avgAssessmentScore: 'Average Assessment Score',
      preferredSubjects: 'Preferred Subjects',
      enrolledCourses: 'Enrolled Courses',
      additionalInfo: 'Additional Information',
      emergencyContact: 'Emergency Contact',
      transportation: 'Transportation',
      medicalNotes: 'Medical Notes',
      dietaryRestrictions: 'Dietary Restrictions',
      academicProgress: 'Academic Progress',
      assignments: 'Assignments',
      avgScore: 'Avg Score',
      subjectPerformance: 'Subject Performance',
      attendanceReport: 'Attendance Report',
      presentDays: 'Present Days',
      totalDays: 'Total Days',
      attendanceRate: 'Attendance Rate',
      tardies: 'Tardies',
      excusedAbsences: 'Excused Absences',
      socialEmotionalLearning: 'Social-Emotional Learning',
      selGoalsProgress: 'SEL Goals Progress',
      selGoalsActivities: 'SEL Goals & Activities',
      recentMoodAverage: 'Recent Mood Average',
      outOf10: 'out of 10',
      behaviorScore: 'Behavior Score',
      recentEmotionalCheckins: 'Recent Emotional Check-ins',
      peerInteraction: 'Peer Interaction',
      emotionalGrowth: 'Emotional Growth',
      extracurricular: 'Extracurricular',
      weeklySchedule: 'Weekly Schedule',
      upcomingAssessments: 'Upcoming Assessments',
      overallGrade: 'Overall Grade',
      strengths: 'Strengths',
      areasForImprovement: 'Areas for Improvement',
      recommendations: 'Recommendations',
      teacherComments: 'Teacher Comments',
      recentAchievements: 'Recent Achievements',
      noProgressReport: 'No progress report available',
      loadingProgressReport: 'Loading progress report...',
      progressLoadError: 'Failed to load progress report',
      photoUploadSuccess: 'Photo uploaded successfully',
      photoUploadError: 'Failed to upload photo',
      parentAddSuccess: 'Parent added successfully',
      parentAddError: 'Failed to add parent',
      assignParent: 'Assign Parent',
      parentEmail: 'Parent Email',
      enterParentEmail: 'Enter parent email address',
      relationship: 'Relationship',
      relationships: {
        mother: 'Mother',
        father: 'Father',
        guardian: 'Guardian',
        other: 'Other',
      },
    },
    idCard: {
      studentCard: 'Student Identity Card',
      employeeCard: 'Employee Identity Card',
      idNumber: 'ID',
      grade: 'Grade',
      scanForVerification: 'Scan QR code for verification',
      footer: 'This card is the property of the school. If found, please return.',
      notFound: 'ID card data not found',
      department: 'Department',
      role: 'Role',
      phone: 'Phone',
      dob: 'Date of Birth',
      hireDate: 'Hire Date',
      emergency: 'Emergency',
    },
    parent: {
      child: {
        grade: "Grade {{grade}}",
        noActivity: "No recent activity",
        lessonsThisWeek: "Lessons this week",
        assessments: "Assessments",
        avgScore: "Average score",
        overallProgress: "Overall progress",
        streak: "{{days}}-day streak",
        keepItUp: "Keep it up!",
        recentAchievements: "Recent achievements",
        viewProgress: "View progress",
        schedule: "Schedule",
        teachers: "Teachers",
      },
    },
    xr: {
      library: {
        advanced: 'Advanced',
        allLevels: 'All levels',
        allSubjects: 'All subjects',
        allTypes: 'All types',
        beginner: 'Beginner',
        difficulty: 'Difficulty',
        intermediate: 'Intermediate',
        newLessonsComingSoon: 'New immersive XR lessons are being developed for this category. Check back for updates!',
        noResults: 'No lessons match your filters',
        search: 'Search XR lessons...',
        startLesson: 'Start lesson',
        subject: 'Subject',
        subtitle: 'Explore immersive 3D and augmented-reality lessons',
        tabs: {
          all: 'All',
          new: 'New',
          popular: 'Popular',
        },
        title: 'XR Lesson Library',
        type: 'Type',
      },
    },
    parentalConsent: {
      back: 'Back',
      errors: {
        consent_already_expired: 'This request expired and the account was deleted.',
        consent_already_granted: 'You already approved this account.',
        consent_already_refused: 'You already refused this account; it was deleted.',
        consent_link_expired: 'This link has expired and the account has been or will be deleted. Your child can sign up again.',
        consent_link_invalid: 'This link is not valid. It may have been used already.',
      },
      grant: 'I approve this account',
      granted: 'Thank you! The account is now open: your child can log in.',
      intro: '{{name}} ({{email}}), aged {{age}}, created a student account on AppAcademia and gave your address as their parent\'s or guardian\'s. The account stays locked until you answer.',
      purpose: 'The AI tutor never receives your child\'s name, and their data is used only for their learning.',
      readPolicy: 'Read our privacy policy',
      refuse: 'I refuse',
      refuseConfirm: 'Delete the account',
      refuseWarning: 'The account and everything in it will be deleted. This cannot be undone.',
      refused: 'The account and its data have been deleted.',
      title: 'Parental permission',
      whatWeKeep: 'We keep their name, e-mail, the exercises they do and their progress, to run their learning space.',
      yourRights: 'You can see, download or delete their data at any time from your parent space, or by writing to {{contact}}.',
    },
    privacy: {
      accessLog: {
        action: {
          change: 'changed',
          view: 'viewed',
        },
        deletedUser: 'Deleted user',
        description: 'Every time someone other than your child opened or changed their record during the last 12 months.',
        empty: 'Nobody has opened this record yet.',
        failed: 'Could not load the log.',
        more: '{{count}} older entries are included in the data download.',
        open: 'Who opened this record',
        relation: {
          admin: 'school administration',
          parent: 'parent',
          staff: 'teacher',
        },
        title: 'Who opened {{name}}\'s record',
      },
      settings: {
        failed: 'Could not save the setting',
        saved: 'Privacy setting saved',
        selAi: 'AI analysis of the social-emotional journal',
        selAiHelp: 'When on, the text pupils write in their journal is sent, without their name, to the AI provider to suggest coping strategies and goals. It can reveal well-being or health information: turn it on only after informing families. When off, entries are analysed on our servers from the pupil\'s own emotion rating.',
        title: 'Privacy settings',
      },
    },
  },
}

export default bundle
